@file:OptIn(kotlin.io.encoding.ExperimentalEncodingApi::class)

package com.example.monetix.ui.screens

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.tween
import androidx.compose.ui.draw.blur
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material.icons.rounded.ArrowDownward
import androidx.compose.material.icons.rounded.ArrowUpward
import androidx.compose.material.icons.rounded.AutoFixHigh
import androidx.compose.material.icons.rounded.Delete
import androidx.compose.material.icons.rounded.Savings
import androidx.compose.material.icons.rounded.SwapHoriz
import androidx.compose.material.icons.rounded.Undo
import androidx.compose.material.icons.rounded.Payments
import androidx.compose.material.icons.rounded.Sync
import androidx.compose.material.icons.outlined.Visibility
import androidx.compose.material.icons.outlined.VisibilityOff
import com.example.monetix.utils.triggerHapticTick
import androidx.compose.material3.*
import com.example.monetix.ui.components.MonetixTextField as OutlinedTextField
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.example.monetix.db.*
import com.example.monetix.ui.components.ModernMoneyText
import com.example.monetix.ui.components.TxLogo
import com.example.monetix.utils.rememberMediaHandler
// 🚀 INCLUSIONE DEL DIALOGO NATIVO
import com.example.monetix.ui.dialogs.SavingsGoalDialog
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import kotlin.random.Random
import kotlin.math.abs
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.LinearEasing
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import app.cash.sqldelight.async.coroutines.awaitAsList
import com.example.monetix.ui.components.MonetixGlassSwitch
import com.example.monetix.utils.AutomationEngine
import kotlinx.coroutines.delay
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDate
import kotlinx.datetime.toLocalDateTime
fun hexToColor(hex: String?): Color {
    return Color.Unspecified
}

@OptIn(kotlin.io.encoding.ExperimentalEncodingApi::class)
fun decodeImageString(uri: String?): Any? {
    if (uri != null && uri.startsWith("data:image")) {
        return try {
            kotlin.io.encoding.Base64.Default.decode(uri.substringAfter("base64,"))
        } catch (e: Exception) {
            uri
        }
    }
    return uri
}

private fun formatPrivateSavingsCurrency(cents: Long, hideBalances: Boolean = false): String {
    if (hideBalances) return "•••• €"
    val absCents = abs(cents)
    val euros = absCents / 100
    val decimals = (absCents % 100).toString().padStart(2, '0')
    val sign = if (cents < 0) "-" else ""
    return "$sign$euros,$decimals €"
}

private fun formatCentsToInputString(cents: Long): String {
    val euros = cents / 100
    val remainder = cents % 100
    return if (remainder == 0L) "$euros" else "$euros,${remainder.toString().padStart(2, '0')}"
}

fun getCurrentWeekNumber(): Int {
    val today = Clock.System.todayIn(TimeZone.currentSystemDefault())
    return (today.dayOfYear / 7) + 1
}

// 🚀 FUNZIONE SUPREMA PER ASSOCIARE SOGNI/PAC/SALVADANAI AL CONTO CORRETTO
fun belongsToAccount(name: String, currentAccId: String, allAccounts: List<AccountEntity>): Boolean {
    val match = Regex("\\[ACC:(.*?)\\]").find(name)
    return if (match != null) {
        match.groupValues[1] == currentAccId
    } else {
        // Retrocompatibilità: se hai vecchi salvadanai senza tag, li assegna di base al primo conto che possiedi
        currentAccId == allAccounts.firstOrNull()?.id
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SavingsAndBudgetScreen(
    db: MonetixDatabase,
    activeAccountId: String?,
    accounts: List<AccountEntity>,
    accountingBalancesMap: Map<String, Long>,
    latestTx: List<TransactionEntity>,
    budgets: List<BudgetEntity>,
    savingsGoals: List<SavingsGoalEntity>,
    categories: List<CategoryEntity>,
    spentByCategoryCents: Map<String, Long>,
    onAddBudget: () -> Unit,
    onAddSavingsGoal: () -> Unit,
    onEditBudget: (BudgetEntity) -> Unit,
    onEditSavingsGoal: (SavingsGoalEntity) -> Unit,
    onSaveGoal: (SavingsGoalEntity) -> Unit,
    onSaveTransaction: (TransactionEntity) -> Unit,
    piggyBanks: List<PiggyBankEntity>,
    onSavePiggyBank: (PiggyBankEntity) -> Unit,
    onDeletePiggyBank: (String) -> Unit,
    availableBalanceCents: Long,
    payPeriodEnd: LocalDate, // 🚀 AGGIUNGI QUESTO PARAMETRO!
    autoSweepEnabled: Boolean,
    sweepDestination: String,
    onToggleAutoSweep: (Boolean) -> Unit,
    onChangeSweepDestination: (String) -> Unit,
    onPopupStateChanged: (Boolean) -> Unit = {},
    hideBalances: Boolean = false
) {
    val scope = rememberCoroutineScope()

    var localHideBalances by remember(hideBalances) { mutableStateOf(hideBalances) }

    val displayBalance = availableBalanceCents

    // 🚀 STATO PER SOGNI E PAC NATIVI
    var showGoalDialog by remember { mutableStateOf(false) }
    var entityToEdit by remember { mutableStateOf<SavingsGoalEntity?>(null) }

    var goalToAddMoney by remember { mutableStateOf<SavingsGoalEntity?>(null) }
    var goalToEmpty by remember { mutableStateOf<SavingsGoalEntity?>(null) }
    var goalToDelete by remember { mutableStateOf<SavingsGoalEntity?>(null) } // 🚀 REINSERITO

    var pacToAddMoney by remember { mutableStateOf<SavingsGoalEntity?>(null) }
    var pacToEmpty by remember { mutableStateOf<SavingsGoalEntity?>(null) }
    var pacToDelete by remember { mutableStateOf<SavingsGoalEntity?>(null) } // 🚀 REINSERITO
    var pacToEdit by remember { mutableStateOf<SavingsGoalEntity?>(null) }
    var showPacSetupDialog by remember { mutableStateOf(false) }
    var pacCheckResult by remember { mutableStateOf<Boolean?>(null) }
    // STATI SALVADANAI
    var piggyBankToEdit by remember { mutableStateOf<PiggyBankEntity?>(null) }
    var piggyBankToDelete by remember { mutableStateOf<PiggyBankEntity?>(null) }
    var piggyBankToTopUp by remember { mutableStateOf<PiggyBankEntity?>(null) }
    var piggyBankToWithdraw by remember { mutableStateOf<PiggyBankEntity?>(null) }
    var showPiggyBankDialog by remember { mutableStateOf(false) }

    var lastSweptBalance by rememberSaveable { mutableStateOf(-1L) }
    if (lastSweptBalance != -1L && availableBalanceCents != lastSweptBalance) {
        lastSweptBalance = -1L
    }

    val today = Clock.System.todayIn(TimeZone.currentSystemDefault())
    val validAccounts = remember(accounts) { accounts.filter { !it.isDeleted && !it.isArchived } }
    val safeAccountId = activeAccountId ?: validAccounts.firstOrNull()?.id ?: ""
    val otherAccounts = remember(validAccounts, safeAccountId) { validAccounts.filter { it.id != safeAccountId } }
    val validBudgets = remember(budgets) { budgets.filter { !it.isDeleted } }

    // 🚀 ORA TUTTE LE LISTE SONO FILTRATE SUL SINGOLO CONTO ATTIVO
    val validSavingsGoals = remember(savingsGoals, safeAccountId, accounts) {
        savingsGoals.filter { !it.isDeleted && !it.name.contains("[PAC:") && belongsToAccount(it.name, safeAccountId, accounts) }
    }
    val validSmartPacs = remember(savingsGoals, safeAccountId, accounts) {
        savingsGoals.filter { !it.isDeleted && it.name.contains("[PAC:") && belongsToAccount(it.name, safeAccountId, accounts) }
    }
    val validPiggyBanks = remember(piggyBanks, safeAccountId, accounts) {
        piggyBanks.filter { !it.isDeleted && belongsToAccount(it.name, safeAccountId, accounts) }
    }

    val todayEpochDays = today.toEpochDays().toLong()
    val periodEndEpoch = payPeriodEnd.toEpochDays().toLong()

    // 🚀 LA FUNZIONE SUPREMA PER IL SALDO IN TEMPO REALE (Allineata al Periodo Contabile)
    // Calcola i soldi riga per riga guardando i movimenti effettivi fino a fine mese.
    // Risolve il problema delle transazioni cancellate e nasconde il futuro lontano!
    val getDynamicBalance = remember(latestTx, todayEpochDays) {
        { entityId: String ->
            latestTx.filter { tx ->
                !tx.isDeleted && tx.dateEpochDay <= todayEpochDays && // 👈 ALLINEATO AD OGGI e ignora vaporizzati!
                        (tx.merchantKey?.contains(":$entityId]") == true || tx.description?.contains(":$entityId]") == true)
            }.sumOf { tx ->
                when {
                    tx.type == "INCOME" -> -tx.amountCents
                    tx.type == "EXPENSE" && tx.amountCents < 0 -> tx.amountCents
                    tx.type == "TRANSFER" && tx.fromAccountId == "salvadanaio_virtuale" -> -tx.amountCents
                    else -> tx.amountCents
                }
            }.coerceAtLeast(0L)
        }
    }

    val createGoalTransaction: (SavingsGoalEntity, Long) -> Unit = { goal, amount ->
        scope.launch(Dispatchers.Default) {
            val nowMs = Clock.System.now().toEpochMilliseconds()
            val txToday = today.toEpochDays().toLong()
            val savingsCat = categories.firstOrNull { it.name.contains("Risparmi", ignoreCase = true) }?.id ?: "cat_savings_auto"

            if (safeAccountId.isNotBlank()) {
                val txId = "tx_goal_${nowMs}_${Random.nextInt(1000)}"
                val newTx = TransactionEntity(
                    id = txId, accountId = safeAccountId, toAccountId = null, fromAccountId = safeAccountId,
                    amountCents = amount, type = "TRANSFER",
                    dateEpochDay = txToday, categoryId = savingsCat, description = "Versamento: ${goal.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()}",
                    merchantKey = "Sogno: ${goal.name} [sav:${goal.id}]",
                    subcategoryText = "Obiettivi", logoEmoji = goal.emoji?.takeIf { it.isNotBlank() } ?: "🎯", logoUri = goal.imageUri ?: "", isHidden = false, isDeleted = false, reminderDays = null,
                    createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                )
                onSaveTransaction(newTx)
            }
        }
    }

    // TRANSAZIONI PAC [pac_sav:]
    val createPacTransaction: (SavingsGoalEntity, Long) -> Unit = { pac, amount ->
        scope.launch(Dispatchers.Default) {
            val nowMs = Clock.System.now().toEpochMilliseconds()
            val txToday = today.toEpochDays().toLong()
            val savingsCat = categories.firstOrNull { it.name.contains("Risparmi", ignoreCase = true) }?.id ?: "cat_savings_auto"

            if (safeAccountId.isNotBlank()) {
                val txId = "tx_pac_${nowMs}_${Random.nextInt(1000)}"
                val cleanName = pac.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()

                // 1. Salviamo la transazione di trasferimento
                val newTx = TransactionEntity(
                    id = txId,
                    accountId = safeAccountId,
                    toAccountId = null,
                    fromAccountId = safeAccountId,
                    amountCents = amount,
                    type = "TRANSFER",
                    dateEpochDay = txToday,
                    categoryId = savingsCat,
                    description = "Versamento Extra PAC: $cleanName",
                    merchantKey = "Smart PAC: ${pac.name} [pac_sav:${pac.id}]",
                    subcategoryText = "Smart PAC",
                    logoEmoji = pac.emoji?.takeIf { it.isNotBlank() } ?: "🤖",
                    logoUri = pac.imageUri ?: "",
                    isHidden = false,
                    isDeleted = false,
                    reminderDays = null,
                    createdAtEpochMs = nowMs,
                    updatedAtEpochMs = nowMs
                )
                onSaveTransaction(newTx)

                // 2. AGGIORNIAMO ANCHE L'OBIETTIVO PAC NEL DATABASE (Fondamentale!)
                val newSavedAmount = pac.savedAmountCents + amount
                val isNowCompleted = pac.targetAmountCents in 1..newSavedAmount
                val updatedPac = pac.copy(
                    savedAmountCents = newSavedAmount,
                    isCompleted = isNowCompleted,
                    updatedAtEpochMs = nowMs
                )
                onSaveGoal(updatedPac)
            }
        }
    }

    val createPiggyTransaction: (PiggyBankEntity, Long) -> Unit = { bank, amount ->
        scope.launch(Dispatchers.Default) {
            val nowMs = Clock.System.now().toEpochMilliseconds()
            val txToday = today.toEpochDays().toLong()

            if (safeAccountId.isNotBlank()) {
                val txId = "tx_piggy_${nowMs}_${Random.nextInt(1000)}"
                val newTx = TransactionEntity(
                    id = txId, accountId = safeAccountId, toAccountId = null, fromAccountId = safeAccountId,
                    amountCents = amount, type = "TRANSFER",
                    dateEpochDay = txToday, categoryId = "", description = "Arrotondamento: ${bank.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()}",
                    merchantKey = "Salvadanaio: ${bank.name} [pb:${bank.id}]",
                    subcategoryText = "Risparmi", logoEmoji = bank.emoji.takeIf { it.isNotBlank() } ?: "🪙", logoUri = bank.imageUri ?: "", isHidden = false, isDeleted = false, reminderDays = null,
                    createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                )
                onSaveTransaction(newTx)
                val updatedBank = bank.copy(accumulatedCents = bank.accumulatedCents + amount, updatedAtEpochMs = nowMs)
                onSavePiggyBank(updatedBank)
            }
        }
    }

    val isAnyPopupOpen = showGoalDialog || entityToEdit != null ||
            goalToAddMoney != null || goalToEmpty != null || goalToDelete != null ||
            pacToAddMoney != null || pacToEmpty != null || pacToDelete != null || pacToEdit != null || showPacSetupDialog ||
            piggyBankToEdit != null || piggyBankToDelete != null || piggyBankToTopUp != null || piggyBankToWithdraw != null || showPiggyBankDialog

    LaunchedEffect(isAnyPopupOpen) {
        onPopupStateChanged(isAnyPopupOpen)
    }

    Scaffold(
        containerColor = Color.Transparent,
    ) { padding ->
        val backgroundBlur by animateDpAsState(
            targetValue = if (isAnyPopupOpen) 12.dp else 0.dp,
            animationSpec = tween(durationMillis = 300),
            label = "bgBlur"
        )

        val hasCustomBg = com.example.monetix.LocalHasCustomBackground.current

        Box(
            modifier = Modifier
                .fillMaxSize()
                .then(
                    if (hasCustomBg) Modifier.background(Color.Transparent)
                    else Modifier.background(
                        Brush.verticalGradient(
                            colors = listOf(
                                Color(0xFF0C4A6E).copy(alpha = 0.7f),
                                Color(0xFF1E1B4B),
                                Color(0xFF0F172A)
                            )
                        )
                    )
                )
                .blur(backgroundBlur)
                .padding(padding)
        ) {
            LazyColumn(
                modifier = Modifier.fillMaxSize(),
                contentPadding = PaddingValues(horizontal = 16.dp, vertical = 12.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
            // =========================================================
            // 🚀 SUPER HERO CARD STILE REVOLUT: SALDO + MAIALINO INTELLIGENTE
            // =========================================================
            item {
                var showSweepOptions by remember { mutableStateOf(false) }
                var isSweeping by remember { mutableStateOf(false) }

                LaunchedEffect(displayBalance) {
                    isSweeping = false
                }

                val spareCents = if (displayBalance > 0) displayBalance % 100 else 0L
                val activeGoals = validSavingsGoals.filter { !it.isCompleted }
                val activePiggies = validPiggyBanks.filter { !it.isDeleted }
                val activePacs = validSmartPacs.filter { !it.isCompleted }

                val canSweep = !autoSweepEnabled && spareCents > 0L && !isSweeping &&
                        (activeGoals.isNotEmpty() || activePiggies.isNotEmpty() || activePacs.isNotEmpty())

                val piggyBgColor by animateColorAsState(
                    targetValue = if (canSweep) Color(0xFFF59E0B) else Color.White.copy(alpha = 0.1f),
                    label = "piggyBg"
                )
                val piggyTintColor by animateColorAsState(
                    targetValue = if (canSweep) Color.Black else Color.White,
                    label = "piggyTint"
                )

                Surface(
                    modifier = Modifier.fillMaxWidth().padding(top = 8.dp),
                    shape = RoundedCornerShape(24.dp),
                    color = Color.White.copy(alpha = 0.08f),
                    border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                ) {
                    Column(modifier = Modifier.fillMaxWidth().padding(20.dp)) {

                        // --- PARTE SUPERIORE: SALDO E MAIALINO UNICO CON OCCHIO ---
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Column {
                                Text("LIQUIDITÀ DISPONIBILE", fontSize = 11.sp, fontWeight = FontWeight.ExtraBold, color = Color(0xFFA0A0A0), letterSpacing = 1.2.sp)
                                Spacer(Modifier.height(6.dp))
                                ModernMoneyText(cents = displayBalance, hideBalances = localHideBalances, color = Color.White, integerFontSize = 36.sp, decimalFontSize = 20.sp, symbolFontSize = 20.sp)
                            }

                            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                                // 👁️ OCCHIO PER OSCURARE I SALDI RISPARMI
                                Surface(
                                    shape = CircleShape,
                                    color = Color.White.copy(alpha = 0.12f),
                                    border = BorderStroke(1.dp, Color.White.copy(alpha = 0.20f)),
                                    modifier = Modifier
                                        .size(44.dp)
                                        .clip(CircleShape)
                                        .clickable {
                                            triggerHapticTick()
                                            localHideBalances = !localHideBalances
                                        }
                                ) {
                                    Box(contentAlignment = Alignment.Center) {
                                        Icon(
                                            if (localHideBalances) Icons.Outlined.VisibilityOff else Icons.Outlined.Visibility,
                                            contentDescription = "Oscura Importi",
                                            tint = Color.White,
                                            modifier = Modifier.size(20.dp)
                                        )
                                    }
                                }

                                // 🐷 L'UNICO MAIALINO INTELLIGENTE 🐷
                                Surface(
                                    shape = CircleShape,
                                    color = piggyBgColor,
                                    modifier = Modifier
                                        .size(52.dp)
                                        .clip(CircleShape)
                                        .clickable(enabled = canSweep) {
                                            isSweeping = true

                                            when (sweepDestination) {
                                                "SOGNI" -> {
                                                    val baseAmount = spareCents / activeGoals.size.coerceAtLeast(1)
                                                    val remainder = spareCents % activeGoals.size.coerceAtLeast(1)
                                                    val sortedGoals = activeGoals.sortedBy { it.savedAmountCents.toFloat() / (it.targetAmountCents.takeIf { t -> t > 0 } ?: 1).toFloat() }
                                                    sortedGoals.forEachIndexed { idx, sortedGoal ->
                                                        val amountToDeposit = baseAmount + if (idx == 0) remainder else 0L
                                                        if (amountToDeposit > 0L) createGoalTransaction(sortedGoal, amountToDeposit)
                                                    }
                                                }
                                                "PAC" -> {
                                                    val baseAmount = spareCents / activePacs.size.coerceAtLeast(1)
                                                    val remainder = spareCents % activePacs.size.coerceAtLeast(1)
                                                    activePacs.forEachIndexed { idx, pac ->
                                                        val amountToDeposit = baseAmount + if (idx == 0) remainder else 0L
                                                        if (amountToDeposit > 0L) createPacTransaction(pac, amountToDeposit)
                                                    }
                                                }
                                                else -> { // SALVADANAI
                                                    val baseAmount = spareCents / activePiggies.size.coerceAtLeast(1)
                                                    val remainder = spareCents % activePiggies.size.coerceAtLeast(1)
                                                    activePiggies.forEachIndexed { idx, bank ->
                                                        val amountToDeposit = baseAmount + if (idx == 0) remainder else 0L
                                                        if (amountToDeposit > 0L) createPiggyTransaction(bank, amountToDeposit)
                                                    }
                                                }
                                            }
                                        }
                                ) {
                                    Icon(Icons.Rounded.Savings, contentDescription = if (canSweep) "Svuota Spiccioli" else null, tint = piggyTintColor, modifier = Modifier.padding(13.dp))
                                }
                            }
                        }

                        Spacer(Modifier.height(16.dp))
                        HorizontalDivider(color = Color.White.copy(alpha = 0.08f))
                        Spacer(Modifier.height(12.dp))

                        // --- PARTE INFERIORE: ARROTONDAMENTO ---
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clickable(
                                    interactionSource = remember { MutableInteractionSource() },
                                    indication = null,
                                    onClick = {
                                        onToggleAutoSweep(!autoSweepEnabled)
                                        if (!autoSweepEnabled) showSweepOptions = true
                                    }
                                ),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.weight(1f)) {
                                Icon(Icons.Rounded.AutoFixHigh, null, tint = Color.White, modifier = Modifier.size(22.dp))
                                Spacer(Modifier.width(14.dp))
                                Column {
                                    Text("Spiccioli Automatici", fontSize = 14.sp, fontWeight = FontWeight.Bold, color = Color.White)

                                    if (autoSweepEnabled) {
                                        Row(
                                            verticalAlignment = Alignment.CenterVertically,
                                            modifier = Modifier
                                                .clip(RoundedCornerShape(8.dp))
                                                .clickable { showSweepOptions = !showSweepOptions }
                                                .padding(top = 2.dp, bottom = 2.dp, end = 8.dp)
                                        ) {
                                            Text("Verso: $sweepDestination", fontSize = 12.sp, color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold)
                                            Spacer(Modifier.width(4.dp))
                                            Icon(Icons.Rounded.AutoFixHigh, null, modifier = Modifier.size(12.dp), tint = Color(0xFF60A5FA))
                                        }
                                    } else {
                                        Text("Metti da parte i resti", fontSize = 12.sp, color = Color(0xFFA0A0A0))
                                    }
                                }
                            }
                            MonetixGlassSwitch(
                                checked = autoSweepEnabled,
                                onCheckedChange = {
                                    onToggleAutoSweep(it)
                                    if (it) showSweepOptions = true
                                },
                                activeColor = Color(0xFF60A5FA)
                            )
                        }

                        // --- MENU A SCOMPARSA DESTINAZIONI ---
                        AnimatedVisibility(visible = autoSweepEnabled && showSweepOptions) {
                            Column(modifier = Modifier.padding(top = 12.dp)) {
                                Text("SCEGLI DOVE INVIARE I RESTI:", fontSize = 10.sp, fontWeight = FontWeight.ExtraBold, color = Color(0xFFA0A0A0), letterSpacing = 1.sp)
                                Spacer(Modifier.height(8.dp))

                                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                    FilterChip(selected = sweepDestination == "SOGNI", onClick = { onChangeSweepDestination("SOGNI"); showSweepOptions = false }, label = { Text("Sogni", fontWeight = FontWeight.Bold) }, leadingIcon = { Text("🎯", fontSize = 14.sp) }, colors = FilterChipDefaults.filterChipColors(selectedContainerColor = Color.White, selectedLabelColor = Color.Black, containerColor = Color.White.copy(alpha = 0.10f), labelColor = Color.White), border = null, shape = RoundedCornerShape(50))
                                    FilterChip(selected = sweepDestination == "SALVADANAI", onClick = { onChangeSweepDestination("SALVADANAI"); showSweepOptions = false }, label = { Text("Salvadanai", fontWeight = FontWeight.Bold) }, leadingIcon = { Text("🪙", fontSize = 14.sp) }, colors = FilterChipDefaults.filterChipColors(selectedContainerColor = Color.White, selectedLabelColor = Color.Black, containerColor = Color.White.copy(alpha = 0.10f), labelColor = Color.White), border = null, shape = RoundedCornerShape(50))
                                    FilterChip(selected = sweepDestination == "PAC", onClick = { onChangeSweepDestination("PAC"); showSweepOptions = false }, label = { Text("PAC", fontWeight = FontWeight.Bold) }, leadingIcon = { Text("🤖", fontSize = 14.sp) }, colors = FilterChipDefaults.filterChipColors(selectedContainerColor = Color.White, selectedLabelColor = Color.Black, containerColor = Color.White.copy(alpha = 0.10f), labelColor = Color.White), border = null, shape = RoundedCornerShape(50))
                                }
                            }
                        }
                    }
                }
            }

            // =========================================================
            // 🎯 I MIEI SOGNI
            // =========================================================
            item {
                SectionHeader(title = "I MIEI SOGNI", buttonText = "+ NUOVO SOGNO", color = Color(0xFF60A5FA), onClick = { showGoalDialog = true })
            }

            if (validSavingsGoals.isEmpty()) {
                item { EmptyStateCard("Ancora nessun sogno nel cassetto.", "🎯") }
            } else {
                item {
                    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                        validSavingsGoals.forEach { goal ->
                            val realBalance = getDynamicBalance(goal.id)
                            SavingsGoalCard(
                                goal = goal.copy(savedAmountCents = realBalance),
                                hideBalances = localHideBalances,
                                onClick = { entityToEdit = goal },
                                onDeleteClick = { goalToDelete = goal },
                                onAddMoney = { goalToAddMoney = goal.copy(savedAmountCents = realBalance) },
                                onEmptyGoal = { goalToEmpty = goal.copy(savedAmountCents = realBalance) }
                            )
                        }
                    }
                }
            }

            // =========================================================
            // 🤖 SMART PAC
            // =========================================================
            item {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(top = 12.dp, bottom = 4.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text("SMART PAC", fontSize = 13.sp, fontWeight = FontWeight.ExtraBold, color = Color(0xFF8B5CF6), letterSpacing = 1.2.sp)
                    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {

                        var isSyncing by remember { mutableStateOf(false) }
                        val rotation by animateFloatAsState(
                            targetValue = if (isSyncing) 360f else 0f,
                            animationSpec = tween(durationMillis = 1000, easing = LinearEasing),
                            label = "syncRotation"
                        )

                        Surface(
                            shape = CircleShape,
                            color = Color(0xFF8B5CF6).copy(alpha = 0.2f),
                            modifier = Modifier.size(32.dp).clip(CircleShape).clickable(enabled = !isSyncing) {
                                isSyncing = true
                                scope.launch(Dispatchers.Default) {
                                    try {
                                        val allGoalsBefore = db.savingsGoalQueries.all().awaitAsList()
                                        val totalBefore = allGoalsBefore.filter { !it.isDeleted && it.name.contains("[PAC:") }.sumOf { it.savedAmountCents }
                                        AutomationEngine.processPendingAutomations(db,
                                            FirestoreHelper()
                                        )
                                        delay(1000)
                                        val allGoalsAfter = db.savingsGoalQueries.all().awaitAsList()
                                        val totalAfter = allGoalsAfter.filter { !it.isDeleted && it.name.contains("[PAC:") }.sumOf { it.savedAmountCents }
                                        pacCheckResult = totalAfter > totalBefore
                                    } catch (e: Exception) {
                                        pacCheckResult = false
                                    } finally {
                                        isSyncing = false
                                    }
                                }
                            }
                        ) {
                            Box(contentAlignment = Alignment.Center) {
                                Icon(
                                    Icons.Rounded.Sync,
                                    contentDescription = "Verifica PAC",
                                    tint = Color(0xFF8B5CF6),
                                    modifier = Modifier.size(18.dp).graphicsLayer { rotationZ = rotation }
                                )
                            }
                        }

                        Surface(
                            onClick = { showPacSetupDialog = true },
                            shape = RoundedCornerShape(20.dp),
                            color = Color(0xFF8B5CF6),
                            modifier = Modifier.height(32.dp)
                        ) {
                            Box(modifier = Modifier.padding(horizontal = 14.dp), contentAlignment = Alignment.Center) {
                                Text("+ NUOVO PAC", fontSize = 11.sp, fontWeight = FontWeight.Bold, color = Color.White)
                            }
                        }
                    }
                }
            }

            if (validSmartPacs.isEmpty()) {
                item { EmptyStateCard("Nessun piano di accumulo configurato.", "🤖") }
            } else {
                item {
                    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                        validSmartPacs.forEach { pac ->
                            val realBalance = getDynamicBalance(pac.id)
                            val pacMatchClassic = Regex("\\[PAC:(\\d+):(\\d+)(?::(\\d+))?\\]").find(pac.name)
                            val pacMatchDyn = Regex("\\[PAC:DYN:([\\d\\-,]+)(?::(\\d+))?\\]").find(pac.name)
                            val freq = if (pacMatchDyn != null && pacMatchDyn.groupValues.size >= 3 && pacMatchDyn.groupValues[2].isNotEmpty()) {
                                pacMatchDyn.groupValues[2].toIntOrNull() ?: 7
                            } else if (pacMatchClassic != null && pacMatchClassic.groupValues.size >= 4 && pacMatchClassic.groupValues[3].isNotEmpty()) {
                                pacMatchClassic.groupValues[3].toIntOrNull() ?: 7
                            } else 7

                            val lastTx = latestTx.filter { 
                                !it.isDeleted && it.merchantKey?.contains("[pac_sav:${pac.id}]") == true && 
                                it.description?.contains("Extra", ignoreCase = true) != true && 
                                (it.type == "TRANSFER" || it.type == "EXPENSE") && it.amountCents > 0
                            }.maxByOrNull { it.dateEpochDay }
                            
                            val nextExecutionEpoch = if (lastTx != null) {
                                lastTx.dateEpochDay + freq
                            } else {
                                val createdEpochDay = try {
                                    Instant.fromEpochMilliseconds(pac.createdAtEpochMs)
                                        .toLocalDateTime(TimeZone.currentSystemDefault()).date.toEpochDays().toLong()
                                } catch (e: Exception) { todayEpochDays }
                                
                                if (createdEpochDay >= todayEpochDays) createdEpochDay + freq else todayEpochDays
                            }

                            SmartPacCard(
                                pac = pac.copy(savedAmountCents = realBalance),
                                nextExecutionEpoch = nextExecutionEpoch,
                                hideBalances = localHideBalances,
                                onClick = { pacToEdit = pac },
                                onDeleteClick = { pacToDelete = pac },
                                onAddMoney = { pacToAddMoney = pac.copy(savedAmountCents = realBalance) },
                                onEmptyGoal = { pacToEmpty = pac.copy(savedAmountCents = realBalance) }
                            )
                        }
                    }
                }
            }

            // =========================================================
            // 🪙 SALVADANAI VIRTUALI
            // =========================================================
            item {
                SectionHeader(title = "SALVADANAI VIRTUALI", buttonText = "+ NUOVO SALVADANAIO", color = Color(0xFF10B981), onClick = { showPiggyBankDialog = true })
            }

            if (validPiggyBanks.isEmpty()) {
                item { EmptyStateCard("Non hai ancora salvadanai attivi.", "🪙") }
            } else {
                item {
                    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                        validPiggyBanks.forEach { bank ->
                            val realBalance = getDynamicBalance(bank.id)
                            PiggyBankCard(
                                bank = bank,
                                currentBalance = realBalance,
                                hideBalances = localHideBalances,
                                onClick = { piggyBankToEdit = bank },
                                onDeleteClick = { piggyBankToDelete = bank },
                                onAddMoney = { piggyBankToTopUp = bank.copy(accumulatedCents = realBalance) },
                                onWithdrawMoney = { piggyBankToWithdraw = bank.copy(accumulatedCents = realBalance) }
                            )
                        }
                    }
                }
            }

            // =========================================================
            // 📊 LIMITI DI SPESA / BUDGET
            // =========================================================
            item {
                SectionHeader(title = "LIMITI DI SPESA", buttonText = "+ NUOVO BUDGET", color = Color(0xFFF59E0B), onClick = onAddBudget)
            }

            if (validBudgets.isEmpty()) {
                item { EmptyStateCard("Imposta un limite per tenere le spese a bada.", "📉") }
            } else {
                item {
                    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                        validBudgets.forEach { budget ->
                            val spent = spentByCategoryCents[budget.categoryId] ?: 0L
                            val category = categories.find { it.id == budget.categoryId }
                            BudgetCard(budget = budget, categoryName = category?.name ?: "Sconosciuta", spentCents = spent, hideBalances = localHideBalances, onClick = { onEditBudget(budget) })
                        }
                    }
                }
            }

            item { Spacer(Modifier.height(100.dp)) }
        }
    }
}

    // ==============================================================
    // 🛠️ INTEGRAZIONE NATIVA POPUP SOGNI/PAC
    // ==============================================================
    if (showGoalDialog || entityToEdit != null) {
        SavingsGoalDialog(
            initial = entityToEdit,
            onDismiss = { showGoalDialog = false; entityToEdit = null },
            onDelete = { id ->
                val goal = savingsGoals.find { it.id == id }
                if (goal != null) onSaveGoal(goal.copy(isDeleted = true, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds()))
                showGoalDialog = false; entityToEdit = null
            },
            onSave = { entity ->
                // 🚀 INIETTIAMO DI NASCOSTO IL TAG DEL CONTO AL SALVATAGGIO
                val hasAcc = entity.name.contains("[ACC:")
                val finalEntity = if (!hasAcc) entity.copy(name = "${entity.name} [ACC:$safeAccountId]") else entity
                onSaveGoal(finalEntity)
                showGoalDialog = false; entityToEdit = null
            }
        )
    }

    // ==============================================================
    // 🛠️ SETUP / MODIFICA SMART PAC
    // ==============================================================
    if (showPacSetupDialog || pacToEdit != null) {
        SmartPacSetupDialog(
            initialPac = pacToEdit,
            onDismiss = { showPacSetupDialog = false; pacToEdit = null },
            onSave = { generatedPacTag, targetCents ->
                val nowMs = Clock.System.now().toEpochMilliseconds()

                if (pacToEdit != null) {
                    // MODIFICA PAC ESISTENTE
                    val updatedPac = pacToEdit!!.copy(
                        name = "$generatedPacTag [ACC:$safeAccountId]",
                        targetAmountCents = targetCents,
                        updatedAtEpochMs = nowMs
                    )
                    onSaveGoal(updatedPac)
                } else {
                    // CREAZIONE NUOVO PAC
                    val newGoal = SavingsGoalEntity(
                        id = "goal_${nowMs}_${Random.nextInt(1000)}",
                        name = "$generatedPacTag [ACC:$safeAccountId]",
                        targetAmountCents = targetCents,
                        savedAmountCents = 0L,
                        emoji = "🤖",
                        imageUri = "",
                        isDeleted = false,
                        isCompleted = false,
                        createdAtEpochMs = nowMs,
                        updatedAtEpochMs = nowMs
                    )
                    onSaveGoal(newGoal)
                }
                showPacSetupDialog = false
                pacToEdit = null
            }
        )
    }

    // Elimina Salvadanaio
    if (piggyBankToDelete != null) {
        val hasFunds = piggyBankToDelete!!.accumulatedCents > 0L
        AlertDialog(
            onDismissRequest = { piggyBankToDelete = null },
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(28.dp),
            title = { Text(if (hasFunds) "Impossibile Eliminare" else "Elimina Salvadanaio", fontWeight = FontWeight.Black, color = if (hasFunds) Color(0xFFF59E0B) else Color.White) },
            text = { 
                Text(
                    if (hasFunds) "Ci sono ancora fondi all'interno. Svuota prima il salvadanaio per poterlo eliminare in sicurezza."
                    else "Vuoi davvero eliminare '${piggyBankToDelete!!.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()}'? L'azione è irreversibile.", 
                    color = Color(0xFFA0A0A0)
                ) 
            },
            confirmButton = { 
                if (hasFunds) {
                    Button(onClick = { piggyBankToDelete = null }, colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFF59E0B), contentColor = Color.White)) { Text("HO CAPITO", fontWeight = FontWeight.Bold) }
                } else {
                    Button(onClick = { onDeletePiggyBank(piggyBankToDelete!!.id); piggyBankToDelete = null }, colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error, contentColor = Color.White)) { Text("ELIMINA", fontWeight = FontWeight.Bold) } 
                }
            },
            dismissButton = { 
                if (!hasFunds) {
                    TextButton(onClick = { piggyBankToDelete = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } 
                }
            }
        )
    }

    // Elimina Sogni / PAC
    val entityToDelete = goalToDelete ?: pacToDelete
    if (entityToDelete != null) {
        val hasFunds = getDynamicBalance(entityToDelete.id) > 0L
        val isPac = entityToDelete.name.contains("[PAC:")
        val titleLabel = if (isPac) "il PAC" else "il Sogno"
        val itemLabel = if (isPac) "lo Smart PAC" else "l'Obiettivo"

        AlertDialog(
            onDismissRequest = { goalToDelete = null; pacToDelete = null },
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(28.dp),
            title = { Text(if (hasFunds) "Impossibile Eliminare" else "Elimina $itemLabel", fontWeight = FontWeight.Black, color = if (hasFunds) Color(0xFFF59E0B) else Color.White) },
            text = { 
                Text(
                    if (hasFunds) "Hai ancora fondi accantonati. Svuota prima $titleLabel per poterlo eliminare in sicurezza."
                    else "Vuoi davvero eliminare '${entityToDelete.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()}'?", 
                    color = Color(0xFFA0A0A0)
                ) 
            },
            confirmButton = {
                if (hasFunds) {
                    Button(
                        onClick = { goalToDelete = null; pacToDelete = null },
                        colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFF59E0B), contentColor = Color.White)
                    ) { Text("HO CAPITO", fontWeight = FontWeight.Bold) }
                } else {
                    Button(
                        onClick = {
                            onSaveGoal(entityToDelete.copy(isDeleted = true, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds()))
                            goalToDelete = null; pacToDelete = null
                        },
                        colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error, contentColor = Color.White)
                    ) { Text("ELIMINA", fontWeight = FontWeight.Bold) }
                }
            },
            dismissButton = { 
                if (!hasFunds) {
                    TextButton(onClick = { goalToDelete = null; pacToDelete = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } 
                }
            }
        )
    }
    // 🚀 POPUP ESITO CONTROLLO PAC
    if (pacCheckResult != null) {
        AlertDialog(
            onDismissRequest = { pacCheckResult = null },
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(28.dp),
            title = { Text("Sincronizzazione PAC", fontWeight = FontWeight.Black, color = Color(0xFF8B5CF6)) },
            text = {
                Text(
                    if (pacCheckResult == true) "✅ Verifica completata!\n\nIl motore ha rilevato le giuste condizioni e ha appena versato la rata nel PAC."
                    else "⚖️ Nessuna operazione necessaria.\n\nI PAC sono già aggiornati oppure il saldo non ha raggiunto la soglia per far scattare le rate.",
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(onClick = { pacCheckResult = null }, colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF8B5CF6))) {
                    Text("OK", fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    // Versa Salvadanaio
    if (piggyBankToTopUp != null) {
        PiggyBankDepositDialog(bank = piggyBankToTopUp!!, maxCents = displayBalance, onDismiss = { piggyBankToTopUp = null }, onSave = { addedCents ->
            val now = Clock.System.now().toEpochMilliseconds()
            val currentBalance = piggyBankToTopUp!!.accumulatedCents
            val updatedBank = piggyBankToTopUp!!.copy(accumulatedCents = currentBalance + addedCents, updatedAtEpochMs = now)
            onSavePiggyBank(updatedBank)

            if (safeAccountId.isNotBlank()) {
                val tx = TransactionEntity(
                    id = "tx_piggy_${now}_${Random.nextInt(1000)}", accountId = safeAccountId, toAccountId = null, fromAccountId = safeAccountId,
                    amountCents = addedCents, type = "TRANSFER", dateEpochDay = today.toEpochDays().toLong(), categoryId = "",
                    description = "Versamento: ${updatedBank.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()}", merchantKey = "Salvadanaio: ${updatedBank.name} [pb:${updatedBank.id}]",
                    subcategoryText = "Risparmi", logoEmoji = updatedBank.emoji.takeIf { it.isNotBlank() } ?: "🪙", logoUri = updatedBank.imageUri ?: "",
                    isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = now, updatedAtEpochMs = now
                )
                onSaveTransaction(tx)
            }
            piggyBankToTopUp = null
        })
    }

    // Versa Sogni
    if (goalToAddMoney != null) {
        SavingsDepositDialog(goal = goalToAddMoney!!, maxCents = displayBalance, onDismiss = { goalToAddMoney = null }, onSave = { addedCents ->
            createGoalTransaction(goalToAddMoney!!, addedCents)
            goalToAddMoney = null
        })
    }

    // Versa PAC
    if (pacToAddMoney != null) {
        SavingsDepositDialog(goal = pacToAddMoney!!, maxCents = displayBalance, onDismiss = { pacToAddMoney = null }, onSave = { addedCents ->
            createPacTransaction(pacToAddMoney!!, addedCents)
            pacToAddMoney = null
        })
    }

    // Crea/Modifica Salvadanaio
    if (showPiggyBankDialog || piggyBankToEdit != null) {
        val currentBalance = piggyBankToEdit?.accumulatedCents ?: 0L

        PiggyBankDialog(
            initialBank = piggyBankToEdit,
            onDismiss = { showPiggyBankDialog = false; piggyBankToEdit = null },
            onSave = { name, emoji, imageUri, initialCents, isAdjustment ->
                scope.launch {
                    val now = Clock.System.now().toEpochMilliseconds()
                    val bankId = piggyBankToEdit?.id ?: "pb_${now}_${Random.nextInt(10000)}"
                    val targetCents = if (isAdjustment) currentBalance + initialCents else initialCents

                    // 🚀 APPLICHIAMO IL TAG INVISIBILE AL SALVADANAIO
                    val accMatch = Regex("\\[ACC:(.*?)\\]").find(piggyBankToEdit?.name ?: "")
                    val oldAccTag = accMatch?.value ?: "[ACC:$safeAccountId]"
                    val cleanName = name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()
                    val finalName = "$cleanName $oldAccTag"

                    val bank = if (piggyBankToEdit != null) piggyBankToEdit!!.copy(name = finalName, emoji = emoji, imageUri = imageUri, accumulatedCents = targetCents, updatedAtEpochMs = now)
                    else PiggyBankEntity(id = bankId, name = finalName, accumulatedCents = targetCents, emoji = emoji, colorHex = "#FFFFFF", imageUri = imageUri, isDeleted = false, createdAtEpochMs = now, updatedAtEpochMs = now)

                    if (initialCents != 0L) {
                        val isDeposit = initialCents > 0
                        val absoluteAmount = if(initialCents < 0) -initialCents else initialCents
                        val adjustmentTx = TransactionEntity(
                            id = "tx_pb_adj_${now}_${Random.nextInt(1000)}", accountId = "sys_ghost", toAccountId = null, fromAccountId = null,
                            amountCents = absoluteAmount, type = "EXPENSE", dateEpochDay = today.toEpochDays().toLong(), categoryId = "",
                            description = if(isDeposit) "Aggiustamento: $cleanName" else "Prelievo (Aggiustamento): $cleanName",
                            merchantKey = "Salvadanaio: ${bank.name} [pb:${bank.id}]",
                            subcategoryText = if(isDeposit) "Versamento Diretto" else "Storno",
                            logoEmoji = "⚖️", logoUri = "", isHidden = true, isDeleted = false, reminderDays = null, createdAtEpochMs = now, updatedAtEpochMs = now
                        )
                        val finalTx = if (isDeposit) adjustmentTx else adjustmentTx.copy(amountCents = -absoluteAmount)
                        onSaveTransaction(finalTx)
                    }

                    onSavePiggyBank(bank)
                    showPiggyBankDialog = false; piggyBankToEdit = null
                }
            }
        )
    }

    // ==============================================================
    // 🏦 DIALOGHI AVANZATI INDIPENDENTI E BLINDATI (SVUOTAMENTO)
    // ==============================================================

    // 1. SVUOTA SALVADANAI VIRTUALI [pb:]
    if (piggyBankToWithdraw != null) {
        val currentBalance = piggyBankToWithdraw!!.accumulatedCents
        val bankCopy = piggyBankToWithdraw!!
        val cleanName = bankCopy.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()

        PiggyBankAdvancedWithdrawDialog(
            bankName = cleanName, bankId = bankCopy.id, currentBalance = currentBalance, accounts = otherAccounts,
            onDismiss = { piggyBankToWithdraw = null },
            onSave = { amountToReturn, action, targetAccId ->
                piggyBankToWithdraw = null
                scope.launch {
                    val nowMs = Clock.System.now().toEpochMilliseconds()
                    if (amountToReturn > 0) {

                        // 🚀 1. CREIAMO SEMPRE LO SBLOCCO (Così le Statistiche scalano i soldi!)
                        val sbloccoTx = TransactionEntity(
                            id = "tx_pb_ret_${nowMs}",
                            accountId = safeAccountId,
                            toAccountId = null,
                            fromAccountId = null,
                            amountCents = -amountToReturn, // Negativo per sottrarre
                            type = "EXPENSE",
                            dateEpochDay = today.toEpochDays().toLong(),
                            categoryId = "",
                            description = "Sblocco fondi da: $cleanName",
                            merchantKey = "Salvadanaio: $cleanName [pb:${bankCopy.id}]", // 🚀 TAG OBBLIGATORIO
                            subcategoryText = "Sblocco Salvadanaio",
                            logoEmoji = "🔓",
                            logoUri = "",
                            isHidden = false,
                            isDeleted = false,
                            reminderDays = null,
                            createdAtEpochMs = nowMs,
                            updatedAtEpochMs = nowMs
                        )
                        onSaveTransaction(sbloccoTx)

                        // 🚀 2. GESTIAMO DOVE VANNO I SOLDI FISICAMENTE
                        when (action) {
                            "AVAILABLE" -> {
                                // I soldi restano sul conto, il saldo si aggiornerà automaticamente dal DB
                            }
                            "CASH" -> {
                                // I soldi escono dal conto bancario e diventano banconote fisiche
                                val cashTx = TransactionEntity(
                                    id = "tx_pb_cash_${nowMs}",
                                    accountId = safeAccountId, // Preleviamo dal conto reale
                                    toAccountId = null,
                                    fromAccountId = null,
                                    amountCents = amountToReturn,
                                    type = "EXPENSE",
                                    dateEpochDay = today.toEpochDays().toLong(),
                                    categoryId = "",
                                    description = "Prelievo Bancomat (da Salvadanaio)",
                                    merchantKey = "Prelievo Contanti", // NESSUN TAG QUI
                                    subcategoryText = "Prelievo Cash",
                                    logoEmoji = "💶",
                                    logoUri = "",
                                    isHidden = false,
                                    isDeleted = false,
                                    reminderDays = null,
                                    createdAtEpochMs = nowMs,
                                    updatedAtEpochMs = nowMs
                                )
                                onSaveTransaction(cashTx)
                            }
                            "TRANSFER" -> {
                                // I soldi vanno su un'altra carta
                                val targetId = targetAccId ?: safeAccountId
                                val transTx = TransactionEntity(
                                    id = "tx_pb_trans_${nowMs}",
                                    accountId = safeAccountId,
                                    toAccountId = targetId,
                                    fromAccountId = safeAccountId,
                                    amountCents = amountToReturn,
                                    type = "TRANSFER",
                                    dateEpochDay = today.toEpochDays().toLong(),
                                    categoryId = "",
                                    description = "Giroconto in uscita (da Salvadanaio)",
                                    merchantKey = "Giroconto", // NESSUN TAG QUI
                                    subcategoryText = "Giroconto",
                                    logoEmoji = "🔄",
                                    logoUri = "",
                                    isHidden = false,
                                    isDeleted = false,
                                    reminderDays = null,
                                    createdAtEpochMs = nowMs,
                                    updatedAtEpochMs = nowMs
                                )
                                onSaveTransaction(transTx)
                            }
                        }
                    }

                    // 🚀 3. AGGIORNAMENTO DEL DB
                    val updatedBank = bankCopy.copy(accumulatedCents = (currentBalance - amountToReturn).coerceAtLeast(0L), updatedAtEpochMs = nowMs)
                    onSavePiggyBank(updatedBank)
                }
            }
        )
    }

    // 2. SVUOTA SOGNI [sav:]
    if (goalToEmpty != null) {
        val goalCopy = goalToEmpty!!
        val cleanName = goalCopy.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()

        SavingsGoalAdvancedWithdrawDialog(
            goalName = cleanName, goalId = goalCopy.id, currentBalance = goalCopy.savedAmountCents, accounts = otherAccounts,
            onDismiss = { goalToEmpty = null },
            onSave = { amountToReturn, action, targetAccId ->
                goalToEmpty = null
                scope.launch {
                    val nowMs = Clock.System.now().toEpochMilliseconds()
                    if (amountToReturn > 0) {

                        // 🚀 1. CREIAMO SEMPRE LO SBLOCCO (Così le Statistiche e le Card scalano i soldi!)
                        val sbloccoTx = TransactionEntity(
                            id = "tx_goal_ret_${nowMs}",
                            accountId = safeAccountId,
                            toAccountId = null,
                            fromAccountId = null,
                            amountCents = -amountToReturn, // Rigorosamente negativo
                            type = "EXPENSE",
                            dateEpochDay = today.toEpochDays().toLong(),
                            categoryId = "",
                            description = "Sblocco fondi da: $cleanName",
                            merchantKey = "Sogno: $cleanName [sav:${goalCopy.id}]", // 🚀 TAG OBBLIGATORIO
                            subcategoryText = "Sblocco Obiettivo",
                            logoEmoji = "🔓",
                            logoUri = "",
                            isHidden = false,
                            isDeleted = false,
                            reminderDays = null,
                            createdAtEpochMs = nowMs,
                            updatedAtEpochMs = nowMs
                        )
                        onSaveTransaction(sbloccoTx)

                        // 🚀 2. GESTIAMO DOVE VANNO I SOLDI FISICAMENTE
                        when (action) {
                            "AVAILABLE" -> {
                                // I soldi restano sul conto, il saldo si aggiornerà automaticamente dal DB
                            }
                            "CASH" -> {
                                // I soldi escono dal conto bancario e diventano banconote fisiche
                                val cashTx = TransactionEntity(
                                    id = "tx_goal_cash_${nowMs}",
                                    accountId = safeAccountId, // 🚀 Dal conto reale
                                    toAccountId = null,
                                    fromAccountId = null,
                                    amountCents = amountToReturn,
                                    type = "EXPENSE",
                                    dateEpochDay = today.toEpochDays().toLong(),
                                    categoryId = "",
                                    description = "Prelievo Bancomat (da Sogno)",
                                    merchantKey = "Prelievo Contanti", // NESSUN TAG SOGNO QUI
                                    subcategoryText = "Prelievo Cash",
                                    logoEmoji = "💶",
                                    logoUri = "",
                                    isHidden = false,
                                    isDeleted = false,
                                    reminderDays = null,
                                    createdAtEpochMs = nowMs,
                                    updatedAtEpochMs = nowMs
                                )
                                onSaveTransaction(cashTx)
                            }
                            "TRANSFER" -> {
                                // I soldi vanno su un'altra carta
                                val targetId = targetAccId ?: safeAccountId
                                val transTx = TransactionEntity(
                                    id = "tx_goal_trans_${nowMs}",
                                    accountId = safeAccountId, // 🚀 Dal conto di origine
                                    toAccountId = targetId, // Al conto destinazione
                                    fromAccountId = safeAccountId,
                                    amountCents = amountToReturn,
                                    type = "TRANSFER",
                                    dateEpochDay = today.toEpochDays().toLong(),
                                    categoryId = "",
                                    description = "Giroconto in uscita (da Sogno)",
                                    merchantKey = "Giroconto", // NESSUN TAG SOGNO QUI
                                    subcategoryText = "Giroconto",
                                    logoEmoji = "🔄",
                                    logoUri = "",
                                    isHidden = false,
                                    isDeleted = false,
                                    reminderDays = null,
                                    createdAtEpochMs = nowMs,
                                    updatedAtEpochMs = nowMs
                                )
                                onSaveTransaction(transTx)
                            }
                        }
                    }

                    // 🚀 3. AGGIORNAMENTO FONDAMENTALE DEL DB: Scaliamo i soldi dal totale del Sogno!
                    val newTotal = (goalCopy.savedAmountCents - amountToReturn).coerceAtLeast(0L)
                    val updatedGoal = goalCopy.copy(
                        savedAmountCents = newTotal,
                        isCompleted = false,
                        updatedAtEpochMs = nowMs
                    )
                    onSaveGoal(updatedGoal)
                }
            }
        )
    }

    // 3. SVUOTA SMART PAC [sav:]
    if (pacToEmpty != null) {
        val pacCopy = pacToEmpty!!
        val cleanName = pacCopy.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()

        SmartPacWithdrawDialog(
            pacName = cleanName, currentBalance = pacCopy.savedAmountCents, accounts = otherAccounts,
            onDismiss = { pacToEmpty = null },
            onSave = { amountToReturn, action, targetAccId ->
                pacToEmpty = null
                scope.launch {
                    val nowMs = Clock.System.now().toEpochMilliseconds()
                    if (amountToReturn > 0) {

                        // 🚀 1. CREIAMO SEMPRE LO SBLOCCO (Così le Statistiche e le Card scalano i soldi!)
                        val sbloccoTx = TransactionEntity(
                            id = "tx_pac_ret_${nowMs}",
                            accountId = safeAccountId,
                            toAccountId = null,
                            fromAccountId = null,
                            amountCents = -amountToReturn, // Rigorosamente negativo
                            type = "EXPENSE",
                            dateEpochDay = today.toEpochDays().toLong(),
                            categoryId = "",
                            description = "Sblocco fondi da PAC: $cleanName",
                            merchantKey = "Smart PAC: $cleanName [pac_sav:${pacCopy.id}]", // 🚀 TAG OBBLIGATORIO
                            subcategoryText = "Sblocco PAC",
                            logoEmoji = "🔓",
                            logoUri = "",
                            isHidden = false,
                            isDeleted = false,
                            reminderDays = null,
                            createdAtEpochMs = nowMs,
                            updatedAtEpochMs = nowMs
                        )
                        onSaveTransaction(sbloccoTx)

                        // 🚀 2. GESTIAMO DOVE VANNO I SOLDI FISICAMENTE
                        when (action) {
                            "AVAILABLE" -> {
                                // I soldi restano sul conto, il saldo si aggiornerà automaticamente dal DB
                            }
                            "CASH" -> {
                                // I soldi escono dal conto bancario e diventano banconote fisiche
                                val cashTx = TransactionEntity(
                                    id = "tx_pac_cash_${nowMs}",
                                    accountId = safeAccountId, // 🚀 Dal conto reale
                                    toAccountId = null,
                                    fromAccountId = null,
                                    amountCents = amountToReturn,
                                    type = "EXPENSE",
                                    dateEpochDay = today.toEpochDays().toLong(),
                                    categoryId = "",
                                    description = "Prelievo Bancomat (da PAC)",
                                    merchantKey = "Prelievo Contanti", // NESSUN TAG PAC QUI
                                    subcategoryText = "Prelievo Cash",
                                    logoEmoji = "💶",
                                    logoUri = "",
                                    isHidden = false,
                                    isDeleted = false,
                                    reminderDays = null,
                                    createdAtEpochMs = nowMs,
                                    updatedAtEpochMs = nowMs
                                )
                                onSaveTransaction(cashTx)
                            }
                            "TRANSFER" -> {
                                // I soldi vanno su un'altra carta
                                val targetId = targetAccId ?: safeAccountId
                                val transTx = TransactionEntity(
                                    id = "tx_pac_trans_${nowMs}",
                                    accountId = safeAccountId, // 🚀 Dal conto di origine
                                    toAccountId = targetId, // Al conto destinazione
                                    fromAccountId = safeAccountId,
                                    amountCents = amountToReturn,
                                    type = "TRANSFER",
                                    dateEpochDay = today.toEpochDays().toLong(),
                                    categoryId = "",
                                    description = "Giroconto in uscita (da PAC)",
                                    merchantKey = "Giroconto", // NESSUN TAG PAC QUI
                                    subcategoryText = "Giroconto PAC",
                                    logoEmoji = "🔄",
                                    logoUri = "",
                                    isHidden = false,
                                    isDeleted = false,
                                    reminderDays = null,
                                    createdAtEpochMs = nowMs,
                                    updatedAtEpochMs = nowMs
                                )
                                onSaveTransaction(transTx)
                            }
                        }
                    }

                    // 🚀 3. AGGIORNAMENTO DEL DB
                    val newTotal = (pacCopy.savedAmountCents - amountToReturn).coerceAtLeast(0L)
                    val updatedPac = pacCopy.copy(savedAmountCents = newTotal, isCompleted = false, updatedAtEpochMs = nowMs)
                    onSaveGoal(updatedPac)
                }
            }
        )
    }
}

// ==========================================
// 🎨 COMPONENTI GRAFICI MODERNIZZATI
// ==========================================

@Composable
fun SectionHeader(title: String, buttonText: String, color: Color, onClick: () -> Unit) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(top = 12.dp, bottom = 4.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(title, fontSize = 13.sp, fontWeight = FontWeight.ExtraBold, color = color, letterSpacing = 1.2.sp)
        Surface(
            onClick = onClick,
            shape = RoundedCornerShape(20.dp),
            color = Color.White.copy(alpha = 0.08f),
            border = BorderStroke(1.dp, color.copy(alpha = 0.4f)),
            modifier = Modifier.height(32.dp)
        ) {
            Box(modifier = Modifier.padding(horizontal = 14.dp), contentAlignment = Alignment.Center) {
                Text(buttonText, fontSize = 11.sp, fontWeight = FontWeight.Bold, color = Color.White)
            }
        }
    }
}

@Composable
fun EmptyStateCard(message: String, emoji: String) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(16.dp),
        color = Color.White.copy(alpha = 0.08f),
        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
    ) {
        Column(modifier = Modifier.fillMaxWidth().padding(20.dp), horizontalAlignment = Alignment.CenterHorizontally) {
            Text(emoji, fontSize = 28.sp)
            Spacer(Modifier.height(6.dp))
            Text(message, color = Color(0xFFA0A0A0), fontSize = 13.sp, fontWeight = FontWeight.Medium)
        }
    }
}

@Composable
fun PiggyBankCard(bank: PiggyBankEntity, currentBalance: Long, hideBalances: Boolean = false, onClick: () -> Unit, onDeleteClick: () -> Unit, onAddMoney: () -> Unit, onWithdrawMoney: () -> Unit) {
    val is52Week = bank.name.contains("52", ignoreCase = true)
    val weekNum = getCurrentWeekNumber()
    val suggestedAmount = if (is52Week) weekNum * 100L else 0L
    val cleanName = bank.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()
    val emeraldColor = Color(0xFF10B981)

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clickable { onClick() }
            .padding(vertical = 8.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.fillMaxWidth()) {
            TxLogo(logoEmoji = bank.emoji.takeIf { it.isNotBlank() } ?: "🪙", logoUri = bank.imageUri?.takeIf { it.isNotBlank() }, name = cleanName, modifier = Modifier.size(44.dp))
            Spacer(Modifier.width(14.dp))
            Column(modifier = Modifier.weight(1f)) {
                Text(text = cleanName.uppercase(), style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                Spacer(Modifier.height(2.dp))
                if (is52Week) {
                    Text(text = "Sfida 52s: Sett. $weekNum (+${formatEuroFromCents(suggestedAmount, false)})", fontSize = 12.sp, fontWeight = FontWeight.Bold, color = emeraldColor)
                } else {
                    Text(text = "Fondo libero", fontSize = 12.sp, color = Color(0xFFA0A0A0))
                }
            }
            Spacer(Modifier.width(8.dp))
            ModernMoneyText(cents = currentBalance, hideBalances = hideBalances, color = Color.White, integerFontSize = 24.sp, decimalFontSize = 14.sp, symbolFontSize = 14.sp)
        }

        Spacer(Modifier.height(10.dp))
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            IconButton(
                onClick = onDeleteClick,
                modifier = Modifier.size(32.dp)
            ) {
                Icon(Icons.Rounded.Delete, contentDescription = "Elimina", tint = MaterialTheme.colorScheme.error.copy(alpha = 0.7f), modifier = Modifier.size(18.dp))
            }

            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                if (currentBalance > 0L) {
                    Surface(
                        onClick = onWithdrawMoney,
                        shape = RoundedCornerShape(20.dp),
                        color = Color.White.copy(alpha = 0.12f),
                        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.20f)),
                        modifier = Modifier.height(32.dp)
                    ) {
                        Box(modifier = Modifier.padding(horizontal = 12.dp), contentAlignment = Alignment.Center) {
                            Text("Preleva", fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color.White)
                        }
                    }
                }
                Surface(
                    onClick = onAddMoney,
                    shape = RoundedCornerShape(20.dp),
                    color = emeraldColor,
                    modifier = Modifier.height(32.dp)
                ) {
                    Box(modifier = Modifier.padding(horizontal = 12.dp), contentAlignment = Alignment.Center) {
                        Text("Versa", fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color.White)
                    }
                }
            }
        }
        Spacer(Modifier.height(12.dp))
        HorizontalDivider(color = Color.White.copy(alpha = 0.08f))
    }
}

@Composable
fun SavingsGoalCard(goal: SavingsGoalEntity, hideBalances: Boolean = false, onClick: () -> Unit, onDeleteClick: () -> Unit, onAddMoney: () -> Unit, onEmptyGoal: () -> Unit) {
    val progressRaw = if (goal.targetAmountCents > 0) (goal.savedAmountCents.toFloat() / goal.targetAmountCents.toFloat()) else 0f
    val progress = progressRaw.coerceIn(0f, 1f)
    val animatedProgress by animateFloatAsState(targetValue = progress, label = "GoalProgress")
    val isCompleted = progress >= 1f
    val cleanName = goal.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clickable { onClick() }
            .padding(vertical = 8.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            TxLogo(logoEmoji = goal.emoji?.takeIf { it.isNotBlank() } ?: "🎯", logoUri = goal.imageUri?.takeIf { it.isNotBlank() }, name = cleanName, modifier = Modifier.size(44.dp))
            Spacer(Modifier.width(14.dp))
            Column(modifier = Modifier.weight(1f)) {
                Text(text = cleanName.uppercase(), style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                Spacer(Modifier.height(2.dp))
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text("Obiettivo: ", fontSize = 12.sp, color = Color(0xFFA0A0A0))
                    ModernMoneyText(cents = goal.targetAmountCents, hideBalances = hideBalances, color = Color(0xFFA0A0A0), integerFontSize = 12.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                }
            }
            Spacer(Modifier.width(8.dp))
            Column(horizontalAlignment = Alignment.End) {
                ModernMoneyText(cents = goal.savedAmountCents, hideBalances = hideBalances, color = Color.White, integerFontSize = 22.sp, decimalFontSize = 14.sp, symbolFontSize = 14.sp)
                if (isCompleted) {
                    Text("Completato 🎉", fontSize = 11.sp, color = Color(0xFF10B981), fontWeight = FontWeight.Bold)
                }
            }
        }

        Spacer(Modifier.height(10.dp))
        LinearProgressIndicator(
            progress = { animatedProgress },
            modifier = Modifier.fillMaxWidth().height(4.dp).clip(CircleShape),
            color = Color(0xFF60A5FA),
            trackColor = Color.White.copy(alpha = 0.1f)
        )

        Spacer(Modifier.height(10.dp))
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            IconButton(
                onClick = onDeleteClick,
                modifier = Modifier.size(32.dp)
            ) {
                Icon(Icons.Rounded.Delete, contentDescription = "Elimina", tint = MaterialTheme.colorScheme.error.copy(alpha = 0.7f), modifier = Modifier.size(18.dp))
            }

            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                if (goal.savedAmountCents > 0L) {
                    Surface(
                        onClick = onEmptyGoal,
                        shape = RoundedCornerShape(20.dp),
                        color = Color.White.copy(alpha = 0.12f),
                        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.20f)),
                        modifier = Modifier.height(32.dp)
                    ) {
                        Box(modifier = Modifier.padding(horizontal = 12.dp), contentAlignment = Alignment.Center) {
                            Text("Sblocca", fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color.White)
                        }
                    }
                }
                if (!isCompleted) {
                    Surface(
                        onClick = onAddMoney,
                        shape = RoundedCornerShape(20.dp),
                        color = Color(0xFF60A5FA),
                        modifier = Modifier.height(32.dp)
                    ) {
                        Box(modifier = Modifier.padding(horizontal = 12.dp), contentAlignment = Alignment.Center) {
                            Text("Versa", fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color.White)
                        }
                    }
                }
            }
        }
        Spacer(Modifier.height(12.dp))
        HorizontalDivider(color = Color.White.copy(alpha = 0.08f))
    }
}

@Composable
fun SmartPacCard(pac: SavingsGoalEntity, nextExecutionEpoch: Long? = null, hideBalances: Boolean = false, onClick: () -> Unit, onDeleteClick: () -> Unit, onAddMoney: () -> Unit, onEmptyGoal: () -> Unit) {
    val progressRaw = if (pac.targetAmountCents > 0) (pac.savedAmountCents.toFloat() / pac.targetAmountCents.toFloat()) else 0f
    val progress = progressRaw.coerceIn(0f, 1f)
    val animatedProgress by animateFloatAsState(targetValue = progress, label = "PacProgress")
    val cleanName = pac.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()
    val purpleColor = Color(0xFF8B5CF6)

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clickable { onClick() }
            .padding(vertical = 8.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Surface(shape = CircleShape, color = purpleColor.copy(alpha = 0.2f), modifier = Modifier.size(44.dp)) { Box(contentAlignment = Alignment.Center) { Text("🤖", fontSize = 20.sp) } }
            Spacer(Modifier.width(14.dp))
            Column(modifier = Modifier.weight(1f)) {
                Text(text = cleanName.uppercase(), style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                Spacer(Modifier.height(2.dp))
                if (nextExecutionEpoch != null) {
                    val date = LocalDate.fromEpochDays(nextExecutionEpoch.toInt())
                    Text("Prossimo: ${date.dayOfMonth}/${date.monthNumber}/${date.year}", fontSize = 11.sp, color = Color(0xFFA0A0A0))
                }
            }
            Spacer(Modifier.width(8.dp))
            Column(horizontalAlignment = Alignment.End) {
                ModernMoneyText(cents = pac.savedAmountCents, hideBalances = hideBalances, color = purpleColor, integerFontSize = 22.sp, decimalFontSize = 14.sp, symbolFontSize = 14.sp)
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text("di ", fontSize = 11.sp, color = Color(0xFFA0A0A0))
                    ModernMoneyText(cents = pac.targetAmountCents, hideBalances = hideBalances, color = Color(0xFFA0A0A0), integerFontSize = 11.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp)
                }
            }
        }

        Spacer(Modifier.height(10.dp))
        LinearProgressIndicator(
            progress = { animatedProgress },
            modifier = Modifier.fillMaxWidth().height(4.dp).clip(CircleShape),
            color = purpleColor,
            trackColor = Color.White.copy(alpha = 0.1f)
        )

        Spacer(Modifier.height(10.dp))
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            IconButton(
                onClick = onDeleteClick,
                modifier = Modifier.size(32.dp)
            ) {
                Icon(Icons.Rounded.Delete, contentDescription = "Elimina", tint = MaterialTheme.colorScheme.error.copy(alpha = 0.7f), modifier = Modifier.size(18.dp))
            }

            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                if (pac.savedAmountCents > 0L) {
                    Surface(
                        onClick = onEmptyGoal,
                        shape = RoundedCornerShape(20.dp),
                        color = Color.White.copy(alpha = 0.12f),
                        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.20f)),
                        modifier = Modifier.height(32.dp)
                    ) {
                        Box(modifier = Modifier.padding(horizontal = 12.dp), contentAlignment = Alignment.Center) {
                            Text("Sblocca", fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color.White)
                        }
                    }
                }
                Surface(
                    onClick = onAddMoney,
                    shape = RoundedCornerShape(20.dp),
                    color = purpleColor,
                    modifier = Modifier.height(32.dp)
                ) {
                    Box(modifier = Modifier.padding(horizontal = 12.dp), contentAlignment = Alignment.Center) {
                        Text("Versa", fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color.White)
                    }
                }
            }
        }
        Spacer(Modifier.height(12.dp))
        HorizontalDivider(color = Color.White.copy(alpha = 0.08f))
    }
}

@Composable
fun BudgetCard(budget: BudgetEntity, categoryName: String, spentCents: Long, hideBalances: Boolean = false, onClick: () -> Unit) {
    val progressRaw = if (budget.limitCents > 0) (spentCents.toFloat() / budget.limitCents.toFloat()) else 0f
    val progress = progressRaw.coerceAtMost(1f)
    val animatedProgress by animateFloatAsState(targetValue = progress, label = "BudgetProgress")
    val amberColor = Color(0xFFF59E0B)
    val isAlert = progress >= 1f

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clickable { onClick() }
            .padding(vertical = 8.dp)
    ) {
        Row(horizontalArrangement = Arrangement.SpaceBetween, modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            Text(categoryName.uppercase(), fontWeight = FontWeight.Bold, fontSize = 15.sp, color = Color.White, maxLines = 1, modifier = Modifier.weight(1f))
            if (isAlert) Icon(Icons.Default.Warning, contentDescription = null, tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(20.dp))
        }
        Spacer(Modifier.height(8.dp))
        Row(horizontalArrangement = Arrangement.SpaceBetween, modifier = Modifier.fillMaxWidth()) {
            Row(verticalAlignment = Alignment.Bottom) {
                Text("Spesi: ", fontSize = 12.sp, color = Color(0xFFA0A0A0))
                ModernMoneyText(cents = spentCents, hideBalances = hideBalances, color = if (isAlert) MaterialTheme.colorScheme.error else Color.White, integerFontSize = 18.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp)
            }
            Row(verticalAlignment = Alignment.Bottom) {
                Text("Limite: ", fontSize = 12.sp, color = Color(0xFFA0A0A0))
                ModernMoneyText(cents = budget.limitCents, hideBalances = hideBalances, color = Color(0xFFA0A0A0), integerFontSize = 14.sp, decimalFontSize = 11.sp, symbolFontSize = 11.sp)
            }
        }
        Spacer(Modifier.height(10.dp))
        LinearProgressIndicator(
            progress = { animatedProgress },
            modifier = Modifier.fillMaxWidth().height(4.dp).clip(CircleShape),
            color = if (isAlert) MaterialTheme.colorScheme.error else amberColor,
            trackColor = Color.White.copy(alpha = 0.1f)
        )
        Spacer(Modifier.height(12.dp))
        HorizontalDivider(color = Color.White.copy(alpha = 0.08f))
    }
}

@Composable
fun ModernWithdrawOptionCard(
    title: String,
    subtitle: String,
    icon: ImageVector,
    selected: Boolean,
    activeColor: Color,
    onClick: () -> Unit
) {
    val bgColor by animateColorAsState(if (selected) activeColor.copy(alpha = 0.25f) else Color.White.copy(alpha = 0.08f))
    val borderColor by animateColorAsState(if (selected) activeColor.copy(alpha = 0.60f) else Color.White.copy(alpha = 0.15f))
    val iconTint by animateColorAsState(if (selected) activeColor else Color(0xFFA0A0A0))

    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(16.dp))
            .clickable { onClick() },
        color = bgColor,
        border = BorderStroke(1.dp, borderColor)
    ) {
        Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
            Surface(
                shape = CircleShape,
                color = if (selected) activeColor.copy(alpha = 0.2f) else Color.White.copy(alpha = 0.10f),
                modifier = Modifier.size(40.dp)
            ) {
                Icon(icon, null, tint = iconTint, modifier = Modifier.padding(8.dp))
            }
            Spacer(Modifier.width(16.dp))
            Column(modifier = Modifier.weight(1f)) {
                Text(title, fontWeight = FontWeight.Bold, fontSize = 15.sp, color = if (selected) activeColor else Color.White)
                Text(subtitle, fontSize = 12.sp, color = Color(0xFFA0A0A0), lineHeight = 14.sp)
            }
            if (selected) {
                Icon(Icons.Filled.CheckCircle, null, tint = activeColor, modifier = Modifier.size(24.dp))
            }
        }
    }
}

// ==============================================================
// 🏦 I 3 DIALOGHI AVANZATI INDIPENDENTI E BLINDATI (MODERNIZZATI DARK)
// ==============================================================

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun PiggyBankAdvancedWithdrawDialog(bankName: String, bankId: String, currentBalance: Long, accounts: List<AccountEntity>, onDismiss: () -> Unit, onSave: (amount: Long, actionType: String, targetAccountId: String?) -> Unit) {
    var amountText by remember { mutableStateOf(formatCentsToInputString(currentBalance)) }
    val cents = (amountText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L
    var isFirstTap by remember { mutableStateOf(true) }

    var selectedAction by remember { mutableStateOf("AVAILABLE") }
    var selectedAccountId by remember { mutableStateOf(accounts.firstOrNull()?.id ?: "") }
    var expandedAccountMenu by remember { mutableStateOf(false) }

    val emeraldColor = Color(0xFF10B981)

    Dialog(onDismissRequest = onDismiss, properties = DialogProperties(usePlatformDefaultWidth = false)) {
        Surface(modifier = Modifier.padding(horizontal = 16.dp, vertical = 24.dp).fillMaxWidth().widthIn(max = 400.dp).imePadding(), shape = RoundedCornerShape(28.dp), color = Color.White.copy(alpha = 0.10f), border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.25f)), shadowElevation = 24.dp) {
            Column(modifier = Modifier.fillMaxWidth().padding(24.dp), horizontalAlignment = Alignment.CenterHorizontally) {

                Surface(shape = CircleShape, color = emeraldColor.copy(alpha = 0.15f), modifier = Modifier.size(56.dp)) {
                    Text("🪙", fontSize = 28.sp, modifier = Modifier.wrapContentSize(Alignment.Center))
                }
                Spacer(Modifier.height(12.dp))
                Text("Preleva da Salvadanaio", fontSize = 20.sp, fontWeight = FontWeight.Black, color = emeraldColor, letterSpacing = (-0.5).sp)
                Text(bankName, fontSize = 14.sp, color = Color(0xFFA0A0A0), fontWeight = FontWeight.Medium)

                Spacer(Modifier.height(24.dp))

                OutlinedTextField(
                    value = amountText,
                    onValueChange = { amountText = it.replace(Regex("[^0-9.,]"), "") },
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                    modifier = Modifier.fillMaxWidth().onFocusChanged { if (it.isFocused && isFirstTap) { amountText = ""; isFirstTap = false } },
                    shape = RoundedCornerShape(20.dp),
                    textStyle = TextStyle(fontSize = 32.sp, fontWeight = FontWeight.Black, textAlign = TextAlign.Center, color = Color.White),
                    colors = OutlinedTextFieldDefaults.colors(focusedBorderColor = emeraldColor, unfocusedBorderColor = emeraldColor.copy(alpha = 0.3f), focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f)),
                    leadingIcon = { Text("€", fontSize = 24.sp, fontWeight = FontWeight.Bold, color = Color(0xFFA0A0A0), modifier = Modifier.padding(start = 16.dp)) }
                )

                Text(text = "Disponibili: ${formatPrivateSavingsCurrency(currentBalance)}", fontSize = 12.sp, color = if (cents > currentBalance) MaterialTheme.colorScheme.error else Color(0xFFA0A0A0), modifier = Modifier.padding(top = 8.dp))

                Spacer(Modifier.height(24.dp))

                ModernWithdrawOptionCard("Rimetti nel Disponibile", "I soldi tornano nel saldo dell'app.", Icons.Rounded.Undo, selectedAction == "AVAILABLE", emeraldColor) { selectedAction = "AVAILABLE" }
                Spacer(Modifier.height(8.dp))
                ModernWithdrawOptionCard("Preleva in Contanti", "Registra un prelievo fisico in banca.", Icons.Rounded.Payments, selectedAction == "CASH", emeraldColor) { selectedAction = "CASH" }

                if (accounts.isNotEmpty()) {
                    Spacer(Modifier.height(8.dp))
                    ModernWithdrawOptionCard("Sposta su altro Conto", "Esegui un giroconto verso un'altra carta.", Icons.Rounded.SwapHoriz, selectedAction == "TRANSFER", emeraldColor) { selectedAction = "TRANSFER" }

                    AnimatedVisibility(visible = selectedAction == "TRANSFER") {
                        Column(modifier = Modifier.padding(top = 8.dp)) {
                            ExposedDropdownMenuBox(expanded = expandedAccountMenu, onExpandedChange = { expandedAccountMenu = !expandedAccountMenu }) {
                                OutlinedTextField(value = accounts.find { it.id == selectedAccountId }?.name ?: "Seleziona Conto", onValueChange = {}, readOnly = true, modifier = Modifier.fillMaxWidth().menuAnchor(), trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expandedAccountMenu) }, shape = RoundedCornerShape(12.dp), colors = OutlinedTextFieldDefaults.colors(focusedBorderColor = emeraldColor, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedTextColor = Color.White, unfocusedTextColor = Color.White))
                                ExposedDropdownMenu(expanded = expandedAccountMenu, onDismissRequest = { expandedAccountMenu = false }, modifier = Modifier.background(Color(0xFF1C1C1E))) { accounts.forEach { account -> DropdownMenuItem(text = { Text(account.name, color = Color.White) }, onClick = { selectedAccountId = account.id; expandedAccountMenu = false }) } }
                            }
                        }
                    }
                }

                Spacer(Modifier.height(24.dp))

                Row(modifier = Modifier.fillMaxWidth()) {
                    TextButton(onClick = onDismiss, modifier = Modifier.weight(1f).height(48.dp)) { Text("ANNULLA", color = Color(0xFFA0A0A0), fontWeight = FontWeight.Bold) }
                    Spacer(Modifier.width(12.dp))
                    Button(onClick = { onSave(cents, selectedAction, if(selectedAction == "TRANSFER") selectedAccountId else null) }, enabled = cents > 0L && cents <= currentBalance && (selectedAction != "TRANSFER" || selectedAccountId.isNotBlank()), modifier = Modifier.weight(1f).height(48.dp), shape = RoundedCornerShape(14.dp), colors = ButtonDefaults.buttonColors(containerColor = emeraldColor)) { Text("CONFERMA", fontWeight = FontWeight.Bold) }
                }
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SavingsGoalAdvancedWithdrawDialog(goalName: String, goalId: String, currentBalance: Long, accounts: List<AccountEntity>, onDismiss: () -> Unit, onSave: (amount: Long, actionType: String, targetAccountId: String?) -> Unit) {
    var amountText by remember { mutableStateOf(formatCentsToInputString(currentBalance)) }
    val cents = (amountText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L
    var isFirstTap by remember { mutableStateOf(true) }

    var selectedAction by remember { mutableStateOf("AVAILABLE") }
    var selectedAccountId by remember { mutableStateOf(accounts.firstOrNull()?.id ?: "") }
    var expandedAccountMenu by remember { mutableStateOf(false) }

    val primaryColor = Color(0xFF60A5FA)

    Dialog(onDismissRequest = onDismiss, properties = DialogProperties(usePlatformDefaultWidth = false)) {
        Surface(modifier = Modifier.padding(horizontal = 16.dp, vertical = 24.dp).fillMaxWidth().widthIn(max = 400.dp).imePadding(), shape = RoundedCornerShape(28.dp), color = Color.White.copy(alpha = 0.10f), border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.25f)), shadowElevation = 24.dp) {
            Column(modifier = Modifier.fillMaxWidth().padding(24.dp), horizontalAlignment = Alignment.CenterHorizontally) {

                Surface(shape = CircleShape, color = primaryColor.copy(alpha = 0.15f), modifier = Modifier.size(56.dp)) {
                    Text("🎯", fontSize = 28.sp, modifier = Modifier.wrapContentSize(Alignment.Center))
                }
                Spacer(Modifier.height(12.dp))
                Text("Sblocca Sogno", fontSize = 20.sp, fontWeight = FontWeight.Black, color = primaryColor, letterSpacing = (-0.5).sp)
                Text(goalName, fontSize = 14.sp, color = Color(0xFFA0A0A0), fontWeight = FontWeight.Medium)

                Spacer(Modifier.height(24.dp))

                OutlinedTextField(
                    value = amountText, onValueChange = { amountText = it.replace(Regex("[^0-9.,]"), "") },
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                    modifier = Modifier.fillMaxWidth().onFocusChanged { if (it.isFocused && isFirstTap) { amountText = ""; isFirstTap = false } },
                    shape = RoundedCornerShape(20.dp),
                    textStyle = TextStyle(fontSize = 32.sp, fontWeight = FontWeight.Black, textAlign = TextAlign.Center, color = Color.White),
                    colors = OutlinedTextFieldDefaults.colors(focusedBorderColor = primaryColor, unfocusedBorderColor = primaryColor.copy(alpha = 0.3f), focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f)),
                    leadingIcon = { Text("€", fontSize = 24.sp, fontWeight = FontWeight.Bold, color = Color(0xFFA0A0A0), modifier = Modifier.padding(start = 16.dp)) }
                )

                Text(text = "Disponibili: ${formatPrivateSavingsCurrency(currentBalance)}", fontSize = 12.sp, color = if (cents > currentBalance) MaterialTheme.colorScheme.error else Color(0xFFA0A0A0), modifier = Modifier.padding(top = 8.dp))

                Spacer(Modifier.height(24.dp))

                ModernWithdrawOptionCard("Rimetti nel Disponibile", "I soldi tornano nel saldo dell'app.", Icons.Rounded.Undo, selectedAction == "AVAILABLE", primaryColor) { selectedAction = "AVAILABLE" }
                Spacer(Modifier.height(8.dp))
                ModernWithdrawOptionCard("Preleva in Contanti", "Registra un prelievo fisico in banca.", Icons.Rounded.Payments, selectedAction == "CASH", primaryColor) { selectedAction = "CASH" }

                if (accounts.isNotEmpty()) {
                    Spacer(Modifier.height(8.dp))
                    ModernWithdrawOptionCard("Sposta su altro Conto", "Esegui un giroconto verso un'altra carta.", Icons.Rounded.SwapHoriz, selectedAction == "TRANSFER", primaryColor) { selectedAction = "TRANSFER" }

                    AnimatedVisibility(visible = selectedAction == "TRANSFER") {
                        Column(modifier = Modifier.padding(top = 8.dp)) {
                            ExposedDropdownMenuBox(expanded = expandedAccountMenu, onExpandedChange = { expandedAccountMenu = !expandedAccountMenu }) {
                                OutlinedTextField(value = accounts.find { it.id == selectedAccountId }?.name ?: "Seleziona Conto", onValueChange = {}, readOnly = true, modifier = Modifier.fillMaxWidth().menuAnchor(), trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expandedAccountMenu) }, shape = RoundedCornerShape(12.dp), colors = OutlinedTextFieldDefaults.colors(focusedBorderColor = primaryColor, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedTextColor = Color.White, unfocusedTextColor = Color.White))
                                ExposedDropdownMenu(expanded = expandedAccountMenu, onDismissRequest = { expandedAccountMenu = false }, modifier = Modifier.background(Color(0xFF1C1C1E))) { accounts.forEach { account -> DropdownMenuItem(text = { Text(account.name, color = Color.White) }, onClick = { selectedAccountId = account.id; expandedAccountMenu = false }) } }
                            }
                        }
                    }
                }

                Spacer(Modifier.height(24.dp))

                Row(modifier = Modifier.fillMaxWidth()) {
                    TextButton(onClick = onDismiss, modifier = Modifier.weight(1f).height(48.dp)) { Text("ANNULLA", color = Color(0xFFA0A0A0), fontWeight = FontWeight.Bold) }
                    Spacer(Modifier.width(12.dp))
                    Button(onClick = { onSave(cents, selectedAction, if(selectedAction == "TRANSFER") selectedAccountId else null) }, enabled = cents > 0L && cents <= currentBalance && (selectedAction != "TRANSFER" || selectedAccountId.isNotBlank()), modifier = Modifier.weight(1f).height(48.dp), shape = RoundedCornerShape(14.dp), colors = ButtonDefaults.buttonColors(containerColor = primaryColor)) { Text("CONFERMA", fontWeight = FontWeight.Bold) }
                }
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SmartPacWithdrawDialog(pacName: String, currentBalance: Long, accounts: List<AccountEntity>, onDismiss: () -> Unit, onSave: (amount: Long, actionType: String, targetAccountId: String?) -> Unit) {
    var amountText by remember { mutableStateOf(formatCentsToInputString(currentBalance)) }
    val cents = (amountText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L
    var isFirstTap by remember { mutableStateOf(true) }

    var selectedAction by remember { mutableStateOf("AVAILABLE") }
    var selectedAccountId by remember { mutableStateOf(accounts.firstOrNull()?.id ?: "") }
    var expandedAccountMenu by remember { mutableStateOf(false) }

    val purpleColor = Color(0xFF8B5CF6)

    Dialog(onDismissRequest = onDismiss, properties = DialogProperties(usePlatformDefaultWidth = false)) {
        Surface(modifier = Modifier.padding(horizontal = 16.dp, vertical = 24.dp).fillMaxWidth().widthIn(max = 400.dp).imePadding(), shape = RoundedCornerShape(28.dp), color = Color.White.copy(alpha = 0.10f), border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.25f)), shadowElevation = 24.dp) {
            Column(modifier = Modifier.fillMaxWidth().padding(24.dp), horizontalAlignment = Alignment.CenterHorizontally) {

                Surface(shape = CircleShape, color = purpleColor.copy(alpha = 0.15f), modifier = Modifier.size(56.dp)) {
                    Text("🤖", fontSize = 28.sp, modifier = Modifier.wrapContentSize(Alignment.Center))
                }
                Spacer(Modifier.height(12.dp))
                Text("Smobilita PAC", fontSize = 20.sp, fontWeight = FontWeight.Black, color = purpleColor, letterSpacing = (-0.5).sp)
                Text(pacName, fontSize = 14.sp, color = Color(0xFFA0A0A0), fontWeight = FontWeight.Medium)

                Spacer(Modifier.height(24.dp))

                OutlinedTextField(
                    value = amountText, onValueChange = { amountText = it.replace(Regex("[^0-9.,]"), "") },
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                    modifier = Modifier.fillMaxWidth().onFocusChanged { if (it.isFocused && isFirstTap) { amountText = ""; isFirstTap = false } },
                    shape = RoundedCornerShape(20.dp),
                    textStyle = TextStyle(fontSize = 32.sp, fontWeight = FontWeight.Black, textAlign = TextAlign.Center, color = Color.White),
                    colors = OutlinedTextFieldDefaults.colors(focusedBorderColor = purpleColor, unfocusedBorderColor = purpleColor.copy(alpha = 0.3f), focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f)),
                    leadingIcon = { Text("€", fontSize = 24.sp, fontWeight = FontWeight.Bold, color = Color(0xFFA0A0A0), modifier = Modifier.padding(start = 16.dp)) }
                )

                Text(text = "Disponibili: ${formatPrivateSavingsCurrency(currentBalance)}", fontSize = 12.sp, color = if (cents > currentBalance) MaterialTheme.colorScheme.error else Color(0xFFA0A0A0), modifier = Modifier.padding(top = 8.dp))

                Spacer(Modifier.height(24.dp))

                ModernWithdrawOptionCard("Rimetti nel Disponibile", "I fondi tornano liberi nel conto principale.", Icons.Rounded.Undo, selectedAction == "AVAILABLE", purpleColor) { selectedAction = "AVAILABLE" }
                Spacer(Modifier.height(8.dp))
                ModernWithdrawOptionCard("Preleva in Contanti", "Registra un'uscita fisica dal conto.", Icons.Rounded.Payments, selectedAction == "CASH", purpleColor) { selectedAction = "CASH" }

                if (accounts.isNotEmpty()) {
                    Spacer(Modifier.height(8.dp))
                    ModernWithdrawOptionCard("Sposta su altro Conto", "Esegui un giroconto verso una carta esterna.", Icons.Rounded.SwapHoriz, selectedAction == "TRANSFER", purpleColor) { selectedAction = "TRANSFER" }

                    AnimatedVisibility(visible = selectedAction == "TRANSFER") {
                        Column(modifier = Modifier.padding(top = 8.dp)) {
                            ExposedDropdownMenuBox(expanded = expandedAccountMenu, onExpandedChange = { expandedAccountMenu = !expandedAccountMenu }) {
                                OutlinedTextField(value = accounts.find { it.id == selectedAccountId }?.name ?: "Seleziona Conto", onValueChange = {}, readOnly = true, modifier = Modifier.fillMaxWidth().menuAnchor(), trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expandedAccountMenu) }, shape = RoundedCornerShape(12.dp), colors = OutlinedTextFieldDefaults.colors(focusedBorderColor = purpleColor, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedTextColor = Color.White, unfocusedTextColor = Color.White))
                                ExposedDropdownMenu(expanded = expandedAccountMenu, onDismissRequest = { expandedAccountMenu = false }, modifier = Modifier.background(Color(0xFF1C1C1E))) { accounts.forEach { account -> DropdownMenuItem(text = { Text(account.name, color = Color.White) }, onClick = { selectedAccountId = account.id; expandedAccountMenu = false }) } }
                            }
                        }
                    }
                }

                Spacer(Modifier.height(24.dp))

                Row(modifier = Modifier.fillMaxWidth()) {
                    TextButton(onClick = onDismiss, modifier = Modifier.weight(1f).height(48.dp)) { Text("ANNULLA", color = Color(0xFFA0A0A0), fontWeight = FontWeight.Bold) }
                    Spacer(Modifier.width(12.dp))
                    Button(onClick = { onSave(cents, selectedAction, if(selectedAction == "TRANSFER") selectedAccountId else null) }, enabled = cents > 0L && cents <= currentBalance && (selectedAction != "TRANSFER" || selectedAccountId.isNotBlank()), modifier = Modifier.weight(1f).height(48.dp), shape = RoundedCornerShape(14.dp), colors = ButtonDefaults.buttonColors(containerColor = purpleColor)) { Text("CONFERMA", fontWeight = FontWeight.Bold) }
                }
            }
        }
    }
}

/// -------------------------------------------------------------
// SETUP SMART PAC (MODALITÀ DOPPIA: FISSA O ELASTICA)
// -------------------------------------------------------------
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SmartPacSetupDialog(initialPac: SavingsGoalEntity? = null, onDismiss: () -> Unit, onSave: (generatedTag: String, targetCents: Long) -> Unit) {
    var name by remember { mutableStateOf("") }
    var targetText by remember { mutableStateOf("") }
    var isDynamicPac by remember { mutableStateOf(false) }
    var frequencyText by remember { mutableStateOf("7") }

    // --- STATI PAC CLASSICO ---
    var calcMode by remember { mutableStateOf("DURATION") }
    var durationText by remember { mutableStateOf("24") }
    var weeklyText by remember { mutableStateOf("") }
    var thresholdText by remember { mutableStateOf("500") }

    // --- STATI PAC DINAMICO (Elastico) ---
    class PacRuleState(initialThreshold: String = "", initialRate: String = "") {
        var threshold by mutableStateOf(initialThreshold)
        var rate by mutableStateOf(initialRate)
    }

    val dynamicRules = remember { mutableStateListOf(
        PacRuleState("500", "10"),
        PacRuleState("1000", "20")
    ) }

    // 🚀 MAGIA: Se stiamo modificando, estraiamo i dati dal tag!
    LaunchedEffect(initialPac) {
        if (initialPac != null) {
            name = initialPac.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()
            targetText = formatCentsToInputString(initialPac.targetAmountCents)

            val pacMatchClassic = Regex("\\[PAC:(\\d+):(\\d+)(?::(\\d+))?\\]").find(initialPac.name)
            val pacMatchDyn = Regex("\\[PAC:DYN:([\\d\\-,]+)(?::(\\d+))?\\]").find(initialPac.name)

            if (pacMatchDyn != null) {
                isDynamicPac = true
                val rulesStr = pacMatchDyn.groupValues[1]
                val parsedRules = rulesStr.split(",").mapNotNull {
                    val p = it.split("-")
                    if (p.size == 2) {
                        PacRuleState(
                            initialThreshold = formatCentsToInputString(p[0].toLongOrNull() ?: 0L),
                            initialRate = formatCentsToInputString(p[1].toLongOrNull() ?: 0L)
                        )
                    } else null
                }
                if (parsedRules.isNotEmpty()) {
                    dynamicRules.clear()
                    dynamicRules.addAll(parsedRules)
                }
                if (pacMatchDyn.groupValues.size >= 3 && pacMatchDyn.groupValues[2].isNotEmpty()) {
                    frequencyText = pacMatchDyn.groupValues[2]
                }
            } else if (pacMatchClassic != null) {
                isDynamicPac = false
                calcMode = "INSTALLMENT"
                thresholdText = formatCentsToInputString(pacMatchClassic.groupValues[1].toLongOrNull() ?: 0L)
                weeklyText = formatCentsToInputString(pacMatchClassic.groupValues[2].toLongOrNull() ?: 0L)
                if (pacMatchClassic.groupValues.size >= 4 && pacMatchClassic.groupValues[3].isNotEmpty()) {
                    frequencyText = pacMatchClassic.groupValues[3]
                }
            }
        }
    }

    val targetCents = (targetText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L
    val weeklyCentsCalculated = if (calcMode == "DURATION") { val m = durationText.toIntOrNull() ?: 0; if (m > 0) (targetCents / (m * 4.33)).toLong() else 0L } else { (weeklyText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L }
    val thresholdCentsClassic = (thresholdText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L

    val listState = rememberLazyListState()
    val coroutineScope = rememberCoroutineScope()

    Dialog(onDismissRequest = onDismiss, properties = DialogProperties(usePlatformDefaultWidth = false)) {
        Surface(modifier = Modifier.padding(horizontal = 16.dp, vertical = 24.dp).fillMaxWidth().widthIn(max = 400.dp).imePadding(), shape = RoundedCornerShape(28.dp), color = Color.White.copy(alpha = 0.10f), border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.25f)), shadowElevation = 24.dp) {
            LazyColumn(state = listState, modifier = Modifier.fillMaxWidth(), contentPadding = PaddingValues(24.dp), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                item {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Rounded.AutoFixHigh, null, tint = Color(0xFF8B5CF6), modifier = Modifier.size(28.dp))
                        Spacer(Modifier.width(12.dp))
                        Text(if (initialPac == null) "Crea Smart PAC" else "Modifica PAC", fontSize = 20.sp, fontWeight = FontWeight.Black, color = Color(0xFF8B5CF6))
                    }
                }

                item {
                    OutlinedTextField(
                        value = name, onValueChange = { name = it },
                        label = { Text("Nome Obiettivo (Es. Auto Nuova)", color = Color(0xFFA0A0A0)) },
                        modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp), singleLine = true,
                        colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF8B5CF6), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                    )
                }
                
                item {
                    OutlinedTextField(
                        value = targetText, onValueChange = { targetText = it.replace(Regex("[^0-9.,]"), "") },
                        label = { Text("Da raggiungere (€)", color = Color(0xFFA0A0A0)) },
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal), modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp), singleLine = true,
                        colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF8B5CF6), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                    )
                }

                item {
                    OutlinedTextField(
                        value = frequencyText, onValueChange = { frequencyText = it.replace(Regex("[^0-9]"), "") },
                        label = { Text("Frequenza esecuzione (giorni)", color = Color(0xFFA0A0A0)) },
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number), modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp), singleLine = true,
                        colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF8B5CF6), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                    )
                }

                // 🚀 INTERRUTTORE MODALITÀ
                item {
                    Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(12.dp)).background(Color.White.copy(alpha = 0.10f))) {
                        Box(modifier = Modifier.weight(1f).clickable { isDynamicPac = false }.background(if(!isDynamicPac) Color(0xFF8B5CF6) else Color.Transparent).padding(vertical = 12.dp), contentAlignment = Alignment.Center) { Text("RATA FISSA", color = if(!isDynamicPac) Color.White else Color(0xFFA0A0A0), fontWeight = FontWeight.Bold, fontSize = 12.sp) }
                        Box(modifier = Modifier.weight(1f).clickable { isDynamicPac = true }.background(if(isDynamicPac) Color(0xFF8B5CF6) else Color.Transparent).padding(vertical = 12.dp), contentAlignment = Alignment.Center) { Text("ELASTICO", color = if(isDynamicPac) Color.White else Color(0xFFA0A0A0), fontWeight = FontWeight.Bold, fontSize = 12.sp) }
                    }
                }

                if (!isDynamicPac) {
                    item {
                        Text("Il PAC preleverà sempre la stessa rata, fermandosi se il saldo scende sotto la soglia.", fontSize = 12.sp, color = Color(0xFFA0A0A0), lineHeight = 16.sp)

                        Row(modifier = Modifier.fillMaxWidth().padding(top = 8.dp).clip(RoundedCornerShape(12.dp)).background(Color.White.copy(alpha = 0.10f))) {
                            Box(modifier = Modifier.weight(1f).clickable { calcMode = "DURATION" }.background(if(calcMode == "DURATION") Color(0xFF8B5CF6).copy(alpha=0.6f) else Color.Transparent).padding(vertical = 8.dp), contentAlignment = Alignment.Center) { Text("MESI", color = if(calcMode == "DURATION") Color.White else Color(0xFFA0A0A0), fontWeight = FontWeight.Bold, fontSize = 11.sp) }
                            Box(modifier = Modifier.weight(1f).clickable { calcMode = "INSTALLMENT" }.background(if(calcMode == "INSTALLMENT") Color(0xFF8B5CF6).copy(alpha=0.6f) else Color.Transparent).padding(vertical = 8.dp), contentAlignment = Alignment.Center) { Text("RATA", color = if(calcMode == "INSTALLMENT") Color.White else Color(0xFFA0A0A0), fontWeight = FontWeight.Bold, fontSize = 11.sp) }
                        }
                    }

                    item {
                        if (calcMode == "DURATION") {
                            OutlinedTextField(value = durationText, onValueChange = { if (it.all { c -> c.isDigit() } && it.length <= 3) durationText = it }, label = { Text("In quanti mesi?", color = Color(0xFFA0A0A0)) }, keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number), modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp), singleLine = true, colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF8B5CF6), unfocusedBorderColor = Color.White.copy(alpha = 0.20f)))
                        } else {
                            OutlinedTextField(value = weeklyText, onValueChange = { weeklyText = it.replace(Regex("[^0-9.,]"), "") }, label = { Text("Rata fissa (€)", color = Color(0xFFA0A0A0)) }, keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal), modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp), singleLine = true, colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF8B5CF6), unfocusedBorderColor = Color.White.copy(alpha = 0.20f)))
                        }
                    }

                    item {
                        OutlinedTextField(value = thresholdText, onValueChange = { thresholdText = it.replace(Regex("[^0-9.,]"), "") }, label = { Text("Soglia di Sicurezza Banca (€)", color = Color(0xFFA0A0A0)) }, keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal), modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp), singleLine = true, colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF8B5CF6), unfocusedBorderColor = Color.White.copy(alpha = 0.20f)))
                    }

                } else {
                    item {
                        Text("L'app sceglierà automaticamente la rata in base alla liquidità che hai sul conto al momento del prelievo.", fontSize = 12.sp, color = Color(0xFFA0A0A0), lineHeight = 16.sp)
                    }
                    
                    items(dynamicRules.size) { index ->
                        val rule = dynamicRules[index]
                        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.fillMaxWidth()) {

                            // 🚀 FIX: Etichetta corta "Soglia (€)", maxLines = 1 e proporzione 1.2f
                            OutlinedTextField(
                                value = rule.threshold,
                                onValueChange = { rule.threshold = it.replace(Regex("[^0-9.,]"), "") },
                                label = { Text("Soglia (€)", maxLines = 1, overflow = TextOverflow.Ellipsis, color = Color(0xFFA0A0A0)) },
                                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                                modifier = Modifier.weight(1.2f),
                                shape = RoundedCornerShape(12.dp),
                                singleLine = true,
                                colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF8B5CF6), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                            )

                            Spacer(Modifier.width(8.dp))

                            // 🚀 FIX: Etichetta "Versa (€)" blindata
                            OutlinedTextField(
                                value = rule.rate,
                                onValueChange = { rule.rate = it.replace(Regex("[^0-9.,]"), "") },
                                label = { Text("Versa (€)", maxLines = 1, overflow = TextOverflow.Ellipsis, color = Color(0xFFA0A0A0)) },
                                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                                modifier = Modifier.weight(1f),
                                shape = RoundedCornerShape(12.dp),
                                singleLine = true,
                                colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF8B5CF6), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                            )

                            Spacer(Modifier.width(4.dp))

                            IconButton(
                                onClick = { if (dynamicRules.size > 1) dynamicRules.removeAt(index) },
                                modifier = Modifier.size(36.dp)
                            ) {
                                Icon(Icons.Rounded.Delete, null, tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(20.dp))
                            }
                        }
                    }
                    item {
                        TextButton(
                            onClick = { 
                                dynamicRules.add(PacRuleState()) 
                                coroutineScope.launch {
                                    delay(100) // wait for recomposition
                                    listState.animateScrollToItem(listState.layoutInfo.totalItemsCount - 1)
                                }
                            }, 
                            modifier = Modifier.fillMaxWidth().padding(top = 4.dp)
                        ) {
                            Text("+ Aggiungi Gradino", color = Color(0xFF8B5CF6), fontWeight = FontWeight.Bold)
                        }
                    }
                }

                item {
                    Row(modifier = Modifier.fillMaxWidth().padding(top = 8.dp), horizontalArrangement = Arrangement.End) {
                        TextButton(onClick = onDismiss) { Text("ANNULLA", color = Color(0xFFA0A0A0), fontWeight = FontWeight.Bold) }
                        Spacer(Modifier.width(12.dp))

                        val freq = frequencyText.toIntOrNull() ?: 7
                        val isSaveEnabled = name.isNotBlank() && targetCents > 0 && freq > 0 && if (!isDynamicPac) weeklyCentsCalculated > 0 else dynamicRules.all { it.threshold.isNotBlank() && it.rate.isNotBlank() }

                        Button(
                            onClick = {
                                val finalName = name.trim()
                                val f = frequencyText.toIntOrNull() ?: 7
                                if (isDynamicPac) {
                                    val rulesStr = dynamicRules.mapNotNull {
                                        val thr = (it.threshold.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong()
                                        val r = (it.rate.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong()
                                        if (thr != null && r != null && r > 0) "$thr-$r" else null
                                    }.joinToString(",")

                                    onSave("$finalName [PAC:DYN:$rulesStr:$f]", targetCents)
                                } else {
                                    onSave("$finalName [PAC:$thresholdCentsClassic:$weeklyCentsCalculated:$f]", targetCents)
                                }
                            },
                            enabled = isSaveEnabled,
                            shape = RoundedCornerShape(12.dp),
                            colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF8B5CF6), disabledContainerColor = Color.White.copy(alpha = 0.08f), disabledContentColor = Color(0xFFA0A0A0))
                        ) { Text("SALVA PAC", fontWeight = FontWeight.Bold) }
                    }
                }
            }
        }
    }
}

// -------------------------------------------------------------
// DIALOGHI STANDARD CON CONTROLLO SCOPERTO (DARK REVOLUT)
// -------------------------------------------------------------

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun BaseRevolutDialog(title: String, subtitle: String? = null, onDismiss: () -> Unit, content: @Composable ColumnScope.() -> Unit) {
    ModalBottomSheet(
        onDismissRequest = onDismiss,
        containerColor = Color.White.copy(alpha = 0.12f),
        shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp),
        dragHandle = { BottomSheetDefaults.DragHandle() }
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp, vertical = 16.dp)
                .navigationBarsPadding()
                .imePadding()
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(title.uppercase(), fontSize = 24.sp, fontWeight = FontWeight.Black, color = Color.White, letterSpacing = (-0.5).sp)
            if (subtitle != null) { Spacer(Modifier.height(4.dp)); Text(subtitle, fontSize = 15.sp, color = Color(0xFFA0A0A0)) }
            Spacer(Modifier.height(32.dp))
            content()
            Spacer(Modifier.height(24.dp))
        }
    }
}

@Composable
fun RevolutDialogButtons(confirmText: String, isConfirmEnabled: Boolean, onDismiss: () -> Unit, onConfirm: () -> Unit) {
    Row(modifier = Modifier.fillMaxWidth().padding(top = 24.dp), horizontalArrangement = Arrangement.End) {
        TextButton(onClick = onDismiss) { Text("ANNULLA", color = Color(0xFFA0A0A0), fontWeight = FontWeight.Bold) }
        Spacer(Modifier.width(12.dp))
        Button(onClick = onConfirm, enabled = isConfirmEnabled, shape = RoundedCornerShape(12.dp), colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White, disabledContainerColor = Color.White.copy(alpha = 0.08f), disabledContentColor = Color(0xFFA0A0A0))) { Text(confirmText, fontWeight = FontWeight.Bold) }
    }
}

@Composable
fun PiggyBankDepositDialog(bank: PiggyBankEntity, maxCents: Long, onDismiss: () -> Unit, onSave: (Long) -> Unit) {
    var amountText by remember { mutableStateOf("") }
    val cents = (amountText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L
    val isOverdraft = cents > maxCents

    BaseRevolutDialog(title = "Versa", subtitle = "in ${bank.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()}", onDismiss = onDismiss) {
        OutlinedTextField(
            value = amountText, onValueChange = { amountText = it.replace(Regex("[^0-9.,]"), "") },
            label = { Text("Importo (€)", color = Color(0xFFA0A0A0)) },
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal), modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp),
            isError = isOverdraft,
            colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF10B981), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
        )
        if (isOverdraft) { Text("Supera il saldo disponibile!", color = MaterialTheme.colorScheme.error, fontSize = 12.sp, modifier = Modifier.padding(top = 4.dp, start = 4.dp)) }
        RevolutDialogButtons(confirmText = "VERSA", isConfirmEnabled = cents > 0L && !isOverdraft, onDismiss = onDismiss, onConfirm = { onSave(cents) })
    }
}

@Composable
fun SavingsDepositDialog(goal: SavingsGoalEntity, maxCents: Long, onDismiss: () -> Unit, onSave: (Long) -> Unit) {
    var amountText by remember { mutableStateOf("") }
    val cents = (amountText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L
    val cleanName = goal.name.replace(Regex("\\[(PAC|ACC):.*?\\]"), "").trim()
    val isOverdraft = cents > maxCents

    BaseRevolutDialog(title = "Versa Extra", subtitle = "in $cleanName", onDismiss = onDismiss) {
        OutlinedTextField(
            value = amountText, onValueChange = { amountText = it.replace(Regex("[^0-9.,]"), "") },
            label = { Text("Importo (€)", color = Color(0xFFA0A0A0)) },
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal), modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp),
            isError = isOverdraft,
            colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF60A5FA), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
        )
        if (isOverdraft) { Text("Supera il saldo disponibile!", color = MaterialTheme.colorScheme.error, fontSize = 12.sp, modifier = Modifier.padding(top = 4.dp, start = 4.dp)) }
        RevolutDialogButtons(confirmText = "VERSA", isConfirmEnabled = cents > 0L && !isOverdraft, onDismiss = onDismiss, onConfirm = { onSave(cents) })
    }
}

@Composable
fun PiggyBankDialog(initialBank: PiggyBankEntity?, onDismiss: () -> Unit, onSave: (name: String, emoji: String, imageUri: String, initialCents: Long, isAdjustment: Boolean) -> Unit) {
    var name by remember { mutableStateOf(initialBank?.name?.replace(Regex("\\[(PAC|ACC):.*?\\]"), "")?.trim() ?: "") }
    var emoji by remember { mutableStateOf(initialBank?.emoji ?: "🪙") }
    var imageUri by remember { mutableStateOf(initialBank?.imageUri ?: "") }
    var initialAmountText by remember { mutableStateOf("") }
    var showEmojiInput by remember { mutableStateOf(false) }
    val mediaHandler = rememberMediaHandler(onImageResult = { uri -> if (uri != null) { imageUri = uri; emoji = "" } }, onVoiceResult = { })

    BaseRevolutDialog(title = if (initialBank == null) "Nuovo Salvadanaio" else "Modifica Salvadanaio", onDismiss = onDismiss) {
        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
            Box(modifier = Modifier.align(Alignment.CenterHorizontally)) { TxLogo(logoEmoji = emoji.takeIf { it.isNotBlank() } ?: "🪙", logoUri = imageUri.takeIf { it.isNotBlank() }, name = name.takeIf { it.isNotBlank() }, modifier = Modifier.size(80.dp)) }
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                OutlinedButton(onClick = { mediaHandler.launchGallery() }, modifier = Modifier.weight(1f), shape = RoundedCornerShape(12.dp), colors = ButtonDefaults.outlinedButtonColors(containerColor = Color.White.copy(alpha = 0.10f), contentColor = Color.White), border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))) { Text("FOTO", color = Color.White) }
                OutlinedButton(onClick = { showEmojiInput = !showEmojiInput }, modifier = Modifier.weight(1f), shape = RoundedCornerShape(12.dp), colors = ButtonDefaults.outlinedButtonColors(containerColor = Color.White.copy(alpha = 0.10f), contentColor = Color.White), border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))) { Text("EMOJI", color = Color.White) }
            }
            AnimatedVisibility(visible = showEmojiInput) { OutlinedTextField(value = emoji, onValueChange = { if(it.length <= 3) { emoji = it; imageUri = "" } }, label = { Text("Inserisci Emoji", color = Color(0xFFA0A0A0)) }, modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp), colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF10B981), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))) }
            OutlinedTextField(value = name, onValueChange = { name = it }, label = { Text("Nome", color = Color(0xFFA0A0A0)) }, modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp), colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF10B981), unfocusedBorderColor = Color.White.copy(alpha = 0.20f)))
            OutlinedTextField(value = initialAmountText, onValueChange = { if (it.isEmpty() || it == "-" || it.replace(",", ".").toDoubleOrNull() != null) initialAmountText = it }, label = { Text(if (initialBank == null) "Fondi iniziali (€)" else "Aggiusta fondo (+/- €)", color = Color(0xFFA0A0A0)) }, keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal), modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp), colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF10B981), unfocusedBorderColor = Color.White.copy(alpha = 0.20f)))
            RevolutDialogButtons(confirmText = "SALVA", isConfirmEnabled = name.isNotBlank(), onDismiss = onDismiss, onConfirm = { val cents = (initialAmountText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L; onSave(name, emoji, imageUri, cents, initialBank != null) })
        }
    }
}